import { useMemo, useState, useCallback, useEffect, useRef, Fragment as Fragment$1, memo } from 'react';
import { useActiveUserId, useMeetingLinks, useBaseEmailVariableValue, useBaseEmailVariables, useUserSearch } from '@bloobirds-it/hooks';
import { isElement, removeNodes, insertNodes, ELEMENT_LINK, getPluginType, moveSelection, insertText, getNodeEntry, createElementAs, select, Media, Box, Link, Image, unwrapList, getParentNode, isType, ELEMENT_CODE_BLOCK, ELEMENT_CODE_LINE, toggleList, createAutoformatPlugin, ELEMENT_H1, ELEMENT_H2, ELEMENT_LI, ELEMENT_UL, ELEMENT_OL, ELEMENT_BLOCKQUOTE, usePlateEditorRef, createPlugins, ELEMENT_IMAGE, upsertLinkText, unwrapLink, wrapLink, insertLink, floatingLinkSelectors, floatingLinkActions, useFloatingLinkSelectors, useVirtualFloatingLink, triggerFloatingLinkEdit, useFloatingLinkEscape, useEditorRef as useEditorRef$1, getPluginOptions as getPluginOptions$1, useHotkeys as useHotkeys$1, triggerFloatingLinkInsert, useOnClickOutside, getSelectionBoundingClientRect, useComposedRef as useComposedRef$1, FloatingLinkUrlInput, FloatingLinkTextInput, FloatingLinkNewTabInput, FloatingLinkEditButton, UnlinkButton, OpenLinkButton, createBlockquotePlugin, createHeadingPlugin, createLinkPlugin, createListPlugin, ELEMENT_PARAGRAPH as ELEMENT_PARAGRAPH$1, isBlockAboveEmpty, isSelectionAtBlockStart, KEYS_HEADING, createExitBreakPlugin, createSelectOnBackspacePlugin, isImageUrl, createPluginFactory, usePlateEditorState, useEventPlateId, isMarkActive, toggleMark, focusEditor as focusEditor$1, someNode as someNode$1, toggleNodeType, MARK_BOLD, MARK_ITALIC, MARK_UNDERLINE, triggerFloatingLink, createPlateUI, withProps, StyledElement, BalloonToolbar, MarkToolbarButton as MarkToolbarButton$1, usePlateSelection, ToolbarButton as ToolbarButton$1, getNodeFragment, comboboxSelectors, getPlugin, getBlockAbove, withoutNormalizing, withoutMergingHistory, ELEMENT_MENTION_INPUT, comboboxActions, ELEMENT_MENTION, isEndPoint, Plate, PlateProvider, createComboboxPlugin, createMentionPlugin, createBasicMarksPlugin, createSingleLinePlugin, createPlateUIEditor, deserializeHtml, serializeHtml } from '@udecode/plate';
import hash from 'object-hash';
import classNames from 'clsx';
import { useSelected, useFocused, useReadOnly } from 'slate-react';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { focusEditor, Box as Box$1, getPluginOptions, getAboveNode, removeNodes as removeNodes$1, insertNodes as insertNodes$1, getPluginType as getPluginType$1, isDefined, setNodes, findNode, getEditorString, isExpanded, getNodeProps, getNodeLeaf, useEditorRef, useHotkeys, usePlateSelectors, getStartPoint, getEndPoint, someNode, useComposedRef, createComponentAs, createElementAs as createElementAs$1, findNodePath, select as select$1, getPointAfter, getInjectedPlugins, pipeInsertDataQuery, usePlateEditorRef as usePlateEditorRef$1, createPluginFactory as createPluginFactory$1, onKeyDownToggleElement } from '@udecode/plate-core';
import { addHttpsIfNeeded, toTitleCase, api, removeScrollOfBox, recoverScrollOfBox } from '@bloobirds-it/utils';
import spacetime from 'spacetime';
import ReactShadowRoot from 'react-shadow-root';
import { Media as Media$1, Image as Image$1 } from '@udecode/plate-media';
import { ToolbarButton, Toolbar, ToolbarSection, useToasts, Icon, useVisible, ToolbarMenu, Section, Item, Dropdown, IconButton, Text, Input, RadioGroup, Radio, Select, Button, Tooltip } from '@bloobirds-it/flamingo-ui';
import { useFloatingLinkSelectors as useFloatingLinkSelectors$1, LinkIcon, ShortTextIcon, LaunchIcon, LinkOffIcon } from '@udecode/plate-link';
import { FloatingInputWrapper, FloatingIconWrapper, FloatingVerticalDivider } from '@udecode/plate-ui-toolbar';
import { getRangeBoundingClientRect, getDefaultBoundingClientRect } from '@udecode/plate-floating';
import { useForm, useController } from 'react-hook-form';
import { Combobox } from '@udecode/plate-ui-combobox';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$8 = ".templateVariable-module_container__tLPbo {\n  color: var(--bloobirds);\n  background-color: var(--veryLightBloobirds);\n  border-radius: 4px;\n  padding: 1px 3px;\n  text-transform: capitalize;\n  white-space: normal;\n}\n\n.templateVariable-module_focused__UiEZw {\n  box-shadow: 0 0 0 2px #b4d5ff;\n}\n\n.templateVariable-module_missingContainer__YgFoZ {\n  color: var(--softTomato);\n  background-color: #ffdbe2;\n  border-radius: 4px;\n  padding: 2px 4px;\n  text-transform: capitalize;\n  white-space: normal;\n}\n\n.templateVariable-module_missingFocused__9CNAD {\n  box-shadow: 0 0 0 2px var(--verySoftTomato);\n}\n";
var styles$8 = {"container":"templateVariable-module_container__tLPbo","focused":"templateVariable-module_focused__UiEZw","missingContainer":"templateVariable-module_missingContainer__YgFoZ","missingFocused":"templateVariable-module_missingFocused__9CNAD"};
styleInject(css_248z$8);

function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$j(Object(source), !0).forEach(function (key) { _defineProperty$k(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$k(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var TemplateVariable = function TemplateVariable(_ref) {
  var attributes = _ref.attributes,
    children = _ref.children,
    element = _ref.element;
    _ref.editor;
  var selected = useSelected();
  var classes = classNames(styles$8.container, _defineProperty$k({}, styles$8.focused, selected));
  return /*#__PURE__*/jsxs("span", _objectSpread$j(_objectSpread$j({}, attributes), {}, {
    children: [/*#__PURE__*/jsxs("span", {
      contentEditable: false,
      className: classes,
      children: [element.group, " ", element.name]
    }), children]
  }));
};

function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$i(Object(source), !0).forEach(function (key) { _defineProperty$j(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$j(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var MissingVariable = function MissingVariable(_ref) {
  var attributes = _ref.attributes,
    children = _ref.children,
    element = _ref.element;
  var selected = useSelected();
  var classes = classNames(styles$8.missingContainer, _defineProperty$j({}, styles$8.missingFocused, selected));
  return /*#__PURE__*/jsxs("span", _objectSpread$i(_objectSpread$i({}, attributes), {}, {
    children: [/*#__PURE__*/jsxs("span", {
      title: "Variable could not be found",
      className: classes,
      children: [element.group, " ", element.name]
    }), children]
  }));
};

var ELEMENT_TEMPLATE_VARIABLE = 'variable';
var ELEMENT_MISSING_VARIABLE = 'missing-variable';
var ELEMENT_SNIPPET = 'snippet';

var ELEMENT_MEETING_LINK = 'meeting-link';
var ELEMENT_MISSING_MEETING_LINK = 'missing-meeting-link';

function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$h(Object(source), !0).forEach(function (key) { _defineProperty$i(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$i(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$9(arr, i) { return _arrayWithHoles$9(arr) || _iterableToArrayLimit$9(arr, i) || _unsupportedIterableToArray$a(arr, i) || _nonIterableRest$9(); }
function _nonIterableRest$9() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$a(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$a(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$a(o, minLen); }
function _arrayLikeToArray$a(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$9(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$9(arr) { if (Array.isArray(arr)) return arr; }
function getMeetingLinkURL$1(userMeetingLinks, node) {
  var linkId = node.linkId;
  if (linkId === '__default__') {
    return userMeetingLinks === null || userMeetingLinks === void 0 ? void 0 : userMeetingLinks.find(function (meetingLink) {
      return meetingLink.defaultLink;
    });
  } else {
    return userMeetingLinks === null || userMeetingLinks === void 0 ? void 0 : userMeetingLinks.find(function (meetingLink) {
      return meetingLink.id === linkId;
    });
  }
}
var withTemplateMeetingLinksOverrides = function withTemplateMeetingLinksOverrides(editor, _ref) {
  var _ref$options = _ref.options,
    replace = _ref$options.replace,
    getUserRelatedMeetingLinks = _ref$options.getUserRelatedMeetingLinks;
  var normalizeNode = editor.normalizeNode;
  editor.normalizeNode = function (entry) {
    var _entry = _slicedToArray$9(entry, 2),
      node = _entry[0],
      path = _entry[1];
    if (isElement(node) && node.type === ELEMENT_MEETING_LINK && replace) {
      var userMeetingLinks = getUserRelatedMeetingLinks(node.userId !== '__me__' ? node.userId : undefined);
      var _ref2 = getMeetingLinkURL$1(userMeetingLinks, node) || {},
        url = _ref2.url;
      removeNodes(editor, {
        at: path
      });
      if (url) {
        insertNodes(editor, _objectSpread$h(_objectSpread$h({}, node), {
          type: ELEMENT_LINK,
          url: addHttpsIfNeeded(url)
        }), {
          at: path
        });
      } else {
        insertNodes(editor, _objectSpread$h(_objectSpread$h({}, node), {
          type: ELEMENT_MISSING_MEETING_LINK
        }), {
          at: path
        });
      }
    } else {
      normalizeNode(entry);
    }
  };
  return editor;
};

var useTemplateMeetingLinksPlugin = function useTemplateMeetingLinksPlugin(replace) {
  var activeUserId = useActiveUserId();
  var _useMeetingLinks = useMeetingLinks(),
    getUserMeetingLinks = _useMeetingLinks.getUserMeetingLinks,
    isLoading = _useMeetingLinks.isLoading;
  function getUserRelatedMeetingLinks(userId) {
    return getUserMeetingLinks(userId || activeUserId);
  }
  return useMemo(function () {
    return {
      key: ELEMENT_MEETING_LINK,
      isElement: true,
      isVoid: true,
      isInline: true,
      withOverrides: withTemplateMeetingLinksOverrides,
      options: {
        replace: replace,
        getUserRelatedMeetingLinks: getUserRelatedMeetingLinks
      },
      plugins: [{
        key: ELEMENT_MISSING_MEETING_LINK,
        isElement: true,
        isInline: true
      }],
      then: function then(_, _ref) {
        var type = _ref.type;
        return {
          options: {
            replace: replace,
            getUserRelatedMeetingLinks: getUserRelatedMeetingLinks
          },
          deserializeHtml: {
            getNode: function getNode(el) {
              return {
                type: type,
                group: el.getAttribute('group'),
                name: el.getAttribute('name'),
                id: el.getAttribute('type')
              };
            },
            rules: [{
              validNodeName: 'MEETING_LINK'
            }]
          }
        };
      },
      serializeHtml: function serializeHtml(_ref2) {
        var element = _ref2.element;
        var group = toTitleCase(element.group);
        var name = toTitleCase(element.name);
        return /*#__PURE__*/jsx(Fragment, {
          children: "".concat(group, ": ").concat(name)
        });
      }
    };
  }, [isLoading]);
};

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$g(Object(source), !0).forEach(function (key) { _defineProperty$h(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$h(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$8(arr, i) { return _arrayWithHoles$8(arr) || _iterableToArrayLimit$8(arr, i) || _unsupportedIterableToArray$9(arr, i) || _nonIterableRest$8(); }
function _nonIterableRest$8() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$9(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$9(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$9(o, minLen); }
function _arrayLikeToArray$9(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$8(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$8(arr) { if (Array.isArray(arr)) return arr; }
var getNodeText = function getNodeText(editor) {
  var isEditorFocused = !!(editor !== null && editor !== void 0 && editor.selection);
  if (isEditorFocused) {
    var _getNodeEntry = getNodeEntry(editor, editor === null || editor === void 0 ? void 0 : editor.selection),
      _getNodeEntry2 = _slicedToArray$8(_getNodeEntry, 1),
      node = _getNodeEntry2[0];
    //@ts-ignore
    return (node === null || node === void 0 ? void 0 : node.text) || null;
  }
  return null;
};
var insertTemplateVariable = function insertTemplateVariable(editor, data) {
  var templateVariable = _objectSpread$g({
    type: getPluginType(editor, ELEMENT_TEMPLATE_VARIABLE),
    children: [{
      text: ''
    }]
  }, data);
  var initialText = getNodeText(editor);
  insertNodes(editor, templateVariable);
  var updatedText = getNodeText(editor);
  var hasBeenReplaced = !!updatedText;
  if (hasBeenReplaced) {
    if (initialText) {
      //@ts-ignore
      var variableLength = updatedText.length - initialText.length;
      moveSelection(editor, {
        unit: 'offset',
        distance: variableLength
      });
      // TODO: Improve template variables micro-interactions,
      //  by doing things like adding/removing spaces if they are already there
    }
  } else {
    moveSelection(editor);
    insertText(editor, ' ');
  }
  focusEditor(editor);
};
var insertMeetingLink = function insertMeetingLink(editor, data) {
  var meetingLink = _objectSpread$g({
    type: getPluginType(editor, ELEMENT_MEETING_LINK),
    children: [{
      text: ''
    }]
  }, data);
  var initialText = getNodeText(editor);
  insertNodes(editor, meetingLink);
  var updatedText = getNodeText(editor);
  var hasBeenReplaced = !!updatedText;
  if (hasBeenReplaced) {
    if (initialText) {
      //@ts-ignore
      var variableLength = updatedText.length - initialText.length;
      moveSelection(editor, {
        unit: 'character',
        distance: variableLength
      });
      // TODO: Improve template variables micro-interactions,
      //  by doing things like adding/removing spaces if they are already there
    }
  } else {
    moveSelection(editor);
    insertText(editor, ' ');
  }
};

function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$f(Object(source), !0).forEach(function (key) { _defineProperty$g(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$g(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$7(arr, i) { return _arrayWithHoles$7(arr) || _iterableToArrayLimit$7(arr, i) || _unsupportedIterableToArray$8(arr, i) || _nonIterableRest$7(); }
function _nonIterableRest$7() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$8(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$8(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen); }
function _arrayLikeToArray$8(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$7(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$7(arr) { if (Array.isArray(arr)) return arr; }
var withTemplateVariableOverrides = function withTemplateVariableOverrides(editor, _ref) {
  var _ref$options = _ref.options,
    replace = _ref$options.replace,
    values = _ref$options.values;
  var normalizeNode = editor.normalizeNode;
  editor.normalizeNode = function (entry) {
    var _entry = _slicedToArray$7(entry, 2),
      node = _entry[0],
      path = _entry[1];
    if (replace && isElement(node) && node.type === ELEMENT_TEMPLATE_VARIABLE) {
      removeNodes(editor, {
        at: path
      });
      var variable = values.find(function (v) {
        return [v.logicRole, v.id].includes(node.id);
      });
      if (variable !== null && variable !== void 0 && variable.value) {
        insertNodes(editor, {
          text: variable.value
        }, {
          at: path
        });
      } else {
        insertNodes(editor, _objectSpread$f(_objectSpread$f({}, node), {}, {
          type: ELEMENT_MISSING_VARIABLE
        }), {
          at: path
        });
      }
    } else {
      normalizeNode(entry);
    }
  };
  return editor;
};

function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) { _defineProperty$f(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$f(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useTemplateVariablesPlugin = function useTemplateVariablesPlugin(_ref) {
  var _ref$replace = _ref.replace,
    replace = _ref$replace === void 0 ? false : _ref$replace;
  var emailVariablesValues = useBaseEmailVariableValue();
  return useMemo(function () {
    var values = Object.values(emailVariablesValues).flat();
    var options = {
      replace: replace,
      values: values
    };
    return {
      key: ELEMENT_TEMPLATE_VARIABLE,
      isElement: true,
      isVoid: true,
      isInline: true,
      options: options,
      withOverrides: withTemplateVariableOverrides,
      plugins: [{
        key: ELEMENT_MISSING_VARIABLE,
        isElement: true,
        isVoid: true,
        isInline: true
      }],
      then: function then(_, _ref2) {
        var type = _ref2.type;
        return {
          options: options,
          deserializeHtml: {
            type: type,
            getNode: function getNode(el) {
              return {
                type: type,
                group: el.getAttribute('group'),
                name: el.getAttribute('name'),
                id: el.getAttribute('type')
              };
            },
            rules: [{
              validNodeName: 'VARIABLE'
            }]
          },
          serializeHtml: function serializeHtml(_ref3) {
            var element = _ref3.element;
            //@ts-ignore
            var variable = values.find(function (v) {
              return v.id === element.id;
            });
            if (variable) {
              return variable === null || variable === void 0 ? void 0 : variable.value;
            } else {
              var group = toTitleCase(element.group);
              var name = toTitleCase(element.name);
              return createElementAs('span', _objectSpread$e(_objectSpread$e({}, element), {}, {
                as: 'missing-variable',
                style: {
                  color: 'var(--softTomato)',
                  backgroundColor: '#ffdbe2',
                  borderRadius: '4px',
                  padding: '2px 4px',
                  textTransform: 'capitalize',
                  whiteSpace: 'normal'
                },
                children: "".concat(group, ": ").concat(name)
              }));
            }
          }
        };
      }
    };
  }, [replace, hash(emailVariablesValues)]);
};

/**
 * Flat map an array of object by key.
 */
var flatMapByKey = function flatMapByKey(arr, key) {
  return arr.flatMap(function (item) {
    var _item$key;
    return (_item$key = item[key]) !== null && _item$key !== void 0 ? _item$key : [];
  });
};

var hasMissingVariables = function hasMissingVariables(root) {
  var nodes = flatMapByKey(root, 'children');
  return nodes.some(function (node) {
    return (node === null || node === void 0 ? void 0 : node.type) === ELEMENT_MISSING_VARIABLE;
  });
};

var ELEMENT_RAW_HTML_BLOCK = 'raw-html-block';

var createRawHTMLBlock = function createRawHTMLBlock(editor, html) {
  var type = getPluginType(editor, ELEMENT_RAW_HTML_BLOCK);
  return {
    html: html,
    type: type,
    children: [{
      text: ''
    }]
  };
};
var insertRawHTMLBlock = function insertRawHTMLBlock(editor, html, options) {
  var rawHTMLBlock = createRawHTMLBlock(editor, html);
  insertNodes(editor, rawHTMLBlock, options);
};

var createRawHTMLBlockPlugin = function createRawHTMLBlockPlugin() {
  return {
    key: ELEMENT_RAW_HTML_BLOCK,
    isElement: true,
    isVoid: true,
    then: function then(editor, _ref) {
      var type = _ref.type;
      return {
        deserializeHtml: {
          getNode: function getNode(el) {
            return {
              type: type,
              html: el.getAttribute('html')
            };
          },
          rules: [{
            validNodeName: 'RAW-HTML-BLOCK'
          }]
        }
      };
    },
    serializeHtml: function serializeHtml(_ref2) {
      var element = _ref2.element;
      return /*#__PURE__*/jsx("div", {
        style: {
          padding: '16px 0'
        },
        dangerouslySetInnerHTML: {
          __html: element.html
        }
      });
    }
  };
};

var css_248z$7 = ".rawHTMLBlock-module_container__GlDen {\n  padding: 0;\n  white-space: initial;\n}\n\n.rawHTMLBlock-module_focused__l7Ri4 {\n  box-shadow: 0 0 0 2px #b4d5ff;\n}\n";
var styles$7 = {"container":"rawHTMLBlock-module_container__GlDen","focused":"rawHTMLBlock-module_focused__l7Ri4"};
styleInject(css_248z$7);

function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) { _defineProperty$e(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$e(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var RawHTMLBlock = function RawHTMLBlock(_ref) {
  var children = _ref.children,
    attributes = _ref.attributes,
    element = _ref.element;
  var selected = useSelected();
  var classes = classNames(styles$7.container, _defineProperty$e({}, styles$7.focused, selected));
  return /*#__PURE__*/jsxs("div", _objectSpread$d(_objectSpread$d({}, attributes), {}, {
    className: classes,
    children: [/*#__PURE__*/jsx("div", {
      contentEditable: false,
      children: /*#__PURE__*/jsx("div", {
        dangerouslySetInnerHTML: {
          __html: element.html
        }
      })
    }), children]
  }));
};

var ELEMENT_REPLY_HISTORY = 'reply-history';

var createReplyHistoryPlugin = function createReplyHistoryPlugin() {
  return {
    key: ELEMENT_REPLY_HISTORY,
    isElement: true,
    isVoid: true,
    then: function then(editor, _ref) {
      var type = _ref.type;
      return {
        deserializeHtml: {
          getNode: function getNode(el) {
            return {
              type: type,
              html: el.getAttribute('html')
            };
          },
          rules: [{
            validNodeName: 'REPLY-HISTORY'
          }]
        }
      };
    },
    serializeHtml: function serializeHtml(_ref2) {
      var element = _ref2.element;
      return /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsxs("div", {
          className: "gmail_quote",
          children: [/*#__PURE__*/jsxs("div", {
            dir: "ltr",
            className: "gmail_attr",
            children: ["On ", spacetime(element.sentAt).format('nice'), ' ', /*#__PURE__*/jsx("a", {
              href: "mailto:".concat(element.sentBy),
              children: element.sentBy
            }), " wrote:", /*#__PURE__*/jsx("br", {})]
          }), /*#__PURE__*/jsx("blockquote", {
            dangerouslySetInnerHTML: {
              __html: element.html
            },
            className: "gmail_quote",
            style: {
              margin: '0px 0px 0px 0.8ex',
              borderLeft: '1px solid rgb(204,204,204)',
              paddingLeft: '1ex'
            }
          })]
        })]
      });
    }
  };
};

var createReplyHistory = function createReplyHistory(editor, _ref) {
  var html = _ref.html,
    sentAt = _ref.sentAt,
    sentBy = _ref.sentBy;
  var type = getPluginType(editor, ELEMENT_REPLY_HISTORY);
  return {
    html: html,
    type: type,
    sentAt: sentAt,
    sentBy: sentBy,
    children: [{
      text: ''
    }]
  };
};

var css_248z$6 = ".replyHistory-module_toggle__-W2Fl {\n  margin-top: 16px;\n  text-align: center;\n  border-radius: 8px;\n  padding: 4px 6px 2px;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border: 0;\n  line-height: 8px;\n  background-color: var(--verySoftPeanut);\n  color: var(--peanut);\n  opacity: 0.8;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  display: grid;\n  grid-auto-flow: column;\n  -moz-column-gap: 1px;\n       column-gap: 1px;\n}\n\n.replyHistory-module_toggle__-W2Fl:focus {\n  outline: none;\n}\n\n.replyHistory-module_toggle__-W2Fl:hover {\n  opacity: 1;\n}\n\n.replyHistory-module_history__pUOp8 {\n  margin-left: 4px;\n  margin-top: 12px;\n  padding-left: 8px;\n  opacity: 0.8;\n  border-left: 1px solid var(--verySoftPeanut);\n  white-space: initial;\n}\n";
var styles$6 = {"toggle":"replyHistory-module_toggle__-W2Fl","history":"replyHistory-module_history__pUOp8"};
styleInject(css_248z$6);

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) { _defineProperty$d(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$6(arr, i) { return _arrayWithHoles$6(arr) || _iterableToArrayLimit$6(arr, i) || _unsupportedIterableToArray$7(arr, i) || _nonIterableRest$6(); }
function _nonIterableRest$6() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$7(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$7(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen); }
function _arrayLikeToArray$7(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$6(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$6(arr) { if (Array.isArray(arr)) return arr; }
var replyStyle = "\n  div[dir='ltr'] + blockquote {\n    opacity: 0.75;\n  }\n  div {\n    white-space: initial;\n  }\n";
var ToggleButton = function ToggleButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/jsxs("button", {
    type: "button",
    className: styles$6.toggle,
    onClick: onClick,
    children: [/*#__PURE__*/jsx("div", {
      children: "\u2022"
    }), /*#__PURE__*/jsx("div", {
      children: "\u2022"
    }), /*#__PURE__*/jsx("div", {
      children: "\u2022"
    })]
  });
};
var ReplyHistory = function ReplyHistory(_ref2) {
  var element = _ref2.element,
    attributes = _ref2.attributes,
    children = _ref2.children,
    editor = _ref2.editor;
  var _useState = useState(false),
    _useState2 = _slicedToArray$6(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  return /*#__PURE__*/jsxs("div", _objectSpread$c(_objectSpread$c({}, attributes), {}, {
    children: [/*#__PURE__*/jsxs("div", {
      contentEditable: false,
      children: [/*#__PURE__*/jsx(ToggleButton, {
        onClick: function onClick() {
          setVisible(!visible);
          setTimeout(function () {
            select(editor, [0, 0]);
          }, 0);
        }
      }), visible && /*#__PURE__*/jsxs(ReactShadowRoot, {
        children: [/*#__PURE__*/jsx("style", {
          children: replyStyle
        }), /*#__PURE__*/jsx("div", {
          className: styles$6.history,
          dangerouslySetInnerHTML: {
            __html: element.html
          }
        })]
      })]
    }), children]
  }));
};

var ELEMENT_IMAGE_LINK = 'image-link';

var css_248z$5 = ".imageLink-module_container__6Ai1C {\n  display: inline-block;\n}\n\n.imageLink-module_image__YkWwM {\n  display: block;\n  padding-left: 0;\n  padding-right: 0;\n  width: 100%;\n  max-width: 100%;\n  cursor: pointer;\n  -o-object-fit: cover;\n     object-fit: cover;\n  border-radius: 3px;\n}\n\n.imageLink-module_focused__LS7Rm {\n  box-shadow: 0 0 0 2px #b4d5ff;\n}\n\n.imageLink-module_root__E8wR6 {\n  padding-top: 0.625rem;\n  padding-bottom: 0.625rem;\n}\n\n.imageLink-module_figure__ddW90 {\n  position: relative;\n  margin: 0;\n}\n\n.imageLink-module_handleRight__j3UZP {\n  display: flex;\n  position: absolute;\n  top: 0;\n  z-index: 10;\n  flex-direction: column;\n  justify-content: center;\n  width: 1.5rem;\n  height: 100%;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n\n  right: -0.75rem;\n  padding-right: 0.75rem;\n  margin-right: -0.75rem;\n  align-items: flex-end;\n}\n\n.imageLink-module_handleLeft__pUKJm {\n  display: flex;\n  position: absolute;\n  top: 0;\n  z-index: 10;\n  flex-direction: column;\n  justify-content: center;\n  width: 1.5rem;\n  height: 100%;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n\n  left: -0.75rem;\n  padding-left: 0.75rem;\n  margin-left: -0.75rem;\n}\n\n.imageLink-module_handleRight__j3UZP::after,\n.imageLink-module_handleLeft__pUKJm::after {\n  display: flex;\n  background-color: #9ca3af;\n  content: ' ';\n  width: 3px;\n  height: 64px;\n  border-radius: 6px;\n}\n\n.imageLink-module_handleRight__j3UZP:focus::after,\n.imageLink-module_handleLeft__pUKJm:focus::after,\n.imageLink-module_handleLeft__pUKJm:hover::after,\n.imageLink-module_handleRight__j3UZP:hover::after,\n.imageLink-module_handleLeft__pUKJm:active::after,\n.imageLink-module_handleRight__j3UZP:active::after {\n  background-color: #3b82f6;\n}\n";
var styles$5 = {"container":"imageLink-module_container__6Ai1C","image":"imageLink-module_image__YkWwM","focused":"imageLink-module_focused__LS7Rm","root":"imageLink-module_root__E8wR6","figure":"imageLink-module_figure__ddW90","handleRight":"imageLink-module_handleRight__j3UZP","handleLeft":"imageLink-module_handleLeft__pUKJm"};
styleInject(css_248z$5);

var _excluded$5 = ["as"];
function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) { _defineProperty$c(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$5(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$5(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ImageLink = function ImageLink(props) {
  props.as;
    var rootProps = _objectWithoutProperties$5(props, _excluded$5);
  var children = rootProps.children,
    nodeProps = rootProps.nodeProps,
    resizableProps = rootProps.resizableProps,
    _rootProps$align = rootProps.align,
    align = _rootProps$align === void 0 ? 'center' : _rootProps$align,
    _rootProps$ignoreRead = rootProps.ignoreReadOnly,
    ignoreReadOnly = _rootProps$ignoreRead === void 0 ? false : _rootProps$ignoreRead;
  var focused = useFocused();
  var selected = useSelected();
  var readOnly = useReadOnly();
  var classes = classNames(styles$5.image, _defineProperty$c({}, styles$5.focused, selected && focused));

  // Fix for useLink hook of @udecode/plate-link
  var linkProps = _objectSpread$b(_objectSpread$b({}, rootProps), {}, {
    element: _objectSpread$b(_objectSpread$b({}, rootProps.element), {}, {
      url: rootProps.element.href,
      target: '_blank'
    })
  });
  return /*#__PURE__*/jsxs(Media.Root, _objectSpread$b(_objectSpread$b({}, rootProps), {}, {
    className: styles$5.root,
    children: [/*#__PURE__*/jsx("figure", {
      className: "group ".concat(styles$5.figure),
      contentEditable: false,
      children: /*#__PURE__*/jsx(Media.Resizable, _objectSpread$b(_objectSpread$b({
        // @ts-ignore
        className: styles$5.resizable,
        handleComponent: {
          left: /*#__PURE__*/jsx(Box, {
            className: styles$5.handleLeft
          }),
          right: /*#__PURE__*/jsx(Box, {
            className: styles$5.handleRight
          })
        },
        align: align,
        readOnly: !ignoreReadOnly && readOnly
      }, resizableProps), {}, {
        children: /*#__PURE__*/jsx(Link.Root, _objectSpread$b(_objectSpread$b({}, linkProps), {}, {
          children: /*#__PURE__*/jsx(Image, _objectSpread$b(_objectSpread$b({
            className: classes
          }, nodeProps), {}, {
            width: '100%'
          }))
        }))
      }))
    }), children]
  }));
};

var css_248z$4 = ".element-module_h1__3ObGL {\n  font-size: 26px;\n  margin: 18px 0;\n  font-weight: 700;\n}\n\n.element-module_h2__oEro8 {\n  font-size: 18px;\n  margin: 16px 0;\n  font-weight: 700;\n}\n\n.element-module_h1__3ObGL:first-child,\n.element-module_h2__oEro8:first-child,\n.element-module_ul__dUYlC:first-child,\n.element-module_ol__NrlPG:first-child,\n.element-module_p__snPMa:first-child {\n  margin-top: 0;\n}\n\n.element-module_h1__3ObGL:last-child,\n.element-module_h2__oEro8:last-child,\n.element-module_ul__dUYlC:last-child,\n.element-module_ol__NrlPG:last-child,\n.element-module_p__snPMa:last-child {\n  margin-bottom: 0;\n}\n\n.element-module_p__snPMa {\n  margin: 0;\n}\n\n.element-module_ul__dUYlC,\n.element-module_ol__NrlPG {\n  padding-left: 40px;\n}\n\n.element-module_p__snPMa,\n.element-module_ol__NrlPG,\n.element-module_ul__dUYlC {\n  line-height: 19px;\n}\n\n.element-module_svgs__BOiCQ svg {\n  width: 20px !important;\n  height: 20px !important;\n}\n";
var styles$4 = {"h1":"element-module_h1__3ObGL","h2":"element-module_h2__oEro8","ul":"element-module_ul__dUYlC","ol":"element-module_ol__NrlPG","p":"element-module_p__snPMa","svgs":"element-module_svgs__BOiCQ"};
styleInject(css_248z$4);

var css_248z$3 = ".meetingLink-module_container__F1Noa {\n  color: var(--softTomato);\n  background-color: #ffdbe2;\n  border-radius: 4px;\n  padding: 2px 4px;\n  text-transform: capitalize;\n  white-space: normal;\n}\n.meetingLink-module_focused__z6mBQ {\n  box-shadow: 0 0 0 2px var(--verySoftTomato);\n}\n";
var styles$3 = {"container":"meetingLink-module_container__F1Noa","focused":"meetingLink-module_focused__z6mBQ"};
styleInject(css_248z$3);

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) { _defineProperty$b(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var MissingMeetingLink = function MissingMeetingLink(_ref) {
  var _element$children$;
  var attributes = _ref.attributes,
    children = _ref.children,
    element = _ref.element;
  var selected = useSelected();
  var classes = classNames(styles$3.container, _defineProperty$b({}, styles$3.focused, selected));
  return /*#__PURE__*/jsxs("span", _objectSpread$a(_objectSpread$a({}, attributes), {}, {
    children: [/*#__PURE__*/jsx("span", {
      title: "User has no default meeting link or this link has been erased",
      className: classes,
      children: element === null || element === void 0 ? void 0 : (_element$children$ = element.children[0]) === null || _element$children$ === void 0 ? void 0 : _element$children$.text
    }), children]
  }));
};

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) { _defineProperty$a(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var getMeetingLinkURL = function getMeetingLinkURL(meetingLinks, linkId) {
  var _meetingLinks$find, _meetingLinks$find2;
  if (linkId === '__default__') return meetingLinks === null || meetingLinks === void 0 ? void 0 : (_meetingLinks$find = meetingLinks.find(function (link) {
    return link.defaultLink;
  })) === null || _meetingLinks$find === void 0 ? void 0 : _meetingLinks$find.url;
  return meetingLinks === null || meetingLinks === void 0 ? void 0 : (_meetingLinks$find2 = meetingLinks.find(function (link) {
    return link.id === linkId;
  })) === null || _meetingLinks$find2 === void 0 ? void 0 : _meetingLinks$find2.url;
};
var MeetingLink = function MeetingLink(_ref) {
  var _elementChildren$;
  var attributes = _ref.attributes,
    element = _ref.element;
  var userId = element.userId,
    linkId = element.linkId,
    elementChildren = element.children;
  var activeUserId = useActiveUserId();
  var _useMeetingLinks = useMeetingLinks(),
    getUserMeetingLinks = _useMeetingLinks.getUserMeetingLinks;
  var meetingLinks = getUserMeetingLinks(userId === '__me__' ? activeUserId : userId);
  var linkURL = addHttpsIfNeeded(getMeetingLinkURL(meetingLinks, linkId));
  return /*#__PURE__*/jsx("span", _objectSpread$9(_objectSpread$9({}, attributes), {}, {
    children: /*#__PURE__*/jsx("a", {
      href: linkURL,
      target: "_blank",
      rel: "noreferrer",
      children: (_elementChildren$ = elementChildren[0]) === null || _elementChildren$ === void 0 ? void 0 : _elementChildren$.text
    })
  }));
};

var _excluded$4 = ["as"];
function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty$9(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$9(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$4(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$4(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ImageElement = function ImageElement(props) {
  var children = props.children,
    nodeProps = props.nodeProps,
    resizableProps = props.resizableProps,
    _props$ignoreReadOnly = props.ignoreReadOnly,
    ignoreReadOnly = _props$ignoreReadOnly === void 0 ? false : _props$ignoreReadOnly;
  props.as;
    var rootProps = _objectWithoutProperties$4(props, _excluded$4);
  var focused = useFocused();
  var selected = useSelected();
  var readOnly = useReadOnly();
  var classes = classNames(styles$5.image, _defineProperty$9({}, styles$5.focused, selected && focused));
  return /*#__PURE__*/jsxs(Media$1.Root, _objectSpread$8(_objectSpread$8({}, rootProps), {}, {
    className: styles$5.root,
    children: [/*#__PURE__*/jsx("figure", {
      className: "group ".concat(styles$5.figure),
      contentEditable: false,
      children: /*#__PURE__*/jsx(Media$1.Resizable, _objectSpread$8(_objectSpread$8({
        // @ts-ignore
        className: styles$5.resizable,
        handleComponent: {
          left: /*#__PURE__*/jsx(Box$1, {
            className: styles$5.handleLeft
          }),
          right: /*#__PURE__*/jsx(Box$1, {
            className: styles$5.handleRight
          })
        },
        readOnly: !ignoreReadOnly && readOnly
      }, resizableProps), {}, {
        children: /*#__PURE__*/jsx(Image$1, _objectSpread$8(_objectSpread$8({
          className: classes
        }, nodeProps), {}, {
          width: '100%'
        }))
      }))
    }), children]
  }));
};

var css_248z$2 = ".editorToolbar-module_label__O-xD2 {\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0;\n}\n\n.editorToolbar-module_input__3rsAn {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  visibility: hidden;\n}\n\n.editorToolbar-module_variableList__Veozi {\n  max-height: 256px;\n  overflow-y: scroll;\n}\n\n.editorToolbar-module_floatingTemplateVariable__yMi39 {\n  height: 100%;\n  padding-right: 12px;\n  z-index: 10;\n}\n\n.editorToolbar-module_meetingLinksDropdownWrapper__B1lZc {\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n  width: 322px;\n  box-sizing: border-box;\n}\n\n/* Linkedin overrides */\n.editorToolbar-module_meetingLinksDropdownWrapper__B1lZc input {\n  margin: 0 !important;\n  box-shadow: none !important;\n  height: auto !important;\n  border: none !important;\n  width: 100%;\n}\n\n.editorToolbar-module_meetingLinksDropdownWrapper__B1lZc input::-moz-placeholder {\n  color: transparent !important;\n}\n\n.editorToolbar-module_meetingLinksDropdownWrapper__B1lZc input::placeholder {\n  color: transparent !important;\n}\n\n.editorToolbar-module_meetingLinksDropdownWrapper__B1lZc input:focus {\n  outline: none !important;\n  background-color: transparent;\n}\n\n.editorToolbar-module_templateMeetingLinksDropdownWrapper__M8Fvt {\n  display: flex;\n  flex-direction: column;\n  padding: 24px 24px 16px 24px;\n  width: 273px;\n}\n\n.editorToolbar-module_templateMeetingLinkCallout__KYS7k {\n  display: flex;\n  width: 239px;\n  height: 48px;\n  align-items: center;\n  padding: 16px;\n  background-color: var(--verySoftBanana);\n  border: solid 1px var(--banana);\n  border-radius: 4px;\n  margin-bottom: 24px;\n}\n\n.editorToolbar-module_templateMeetingLinkCallout__KYS7k > svg {\n  width: 96px;\n  margin-right: 16px;\n}\n\n.editorToolbar-module_meetingLinksHeader__B9OTV {\n  margin-bottom: 8px;\n}\n\n.editorToolbar-module_meetingLinksTextDisplayInput__pZhXE {\n  margin-bottom: 18px;\n}\n\n.editorToolbar-module_radioGroup__q98mq {\n  margin-bottom: 16px;\n}\n\n.editorToolbar-module_dropdownSelects__eZ5PX > * {\n  margin-bottom: 16px;\n}\n\n.editorToolbar-module_addButton__T-sCA {\n  display: flex;\n  justify-content: end;\n}\n\n.editorToolbar-module_templateVariable__mwldh {\n  display: flex;\n  height: 100%;\n  align-items: center;\n}\n\n.editorToolbar-module_templateVariable__mwldh > div {\n  height: 24px;\n  display: flex !important;\n  align-items: center;\n}\n\n.editorToolbar-module_toolbar__-f8sS > * {\n  font-size: 1rem;\n}\n";
var styles$2 = {"label":"editorToolbar-module_label__O-xD2","input":"editorToolbar-module_input__3rsAn","variableList":"editorToolbar-module_variableList__Veozi","floatingTemplateVariable":"editorToolbar-module_floatingTemplateVariable__yMi39","meetingLinksDropdownWrapper":"editorToolbar-module_meetingLinksDropdownWrapper__B1lZc","templateMeetingLinksDropdownWrapper":"editorToolbar-module_templateMeetingLinksDropdownWrapper__M8Fvt","templateMeetingLinkCallout":"editorToolbar-module_templateMeetingLinkCallout__KYS7k","meetingLinksHeader":"editorToolbar-module_meetingLinksHeader__B9OTV","meetingLinksTextDisplayInput":"editorToolbar-module_meetingLinksTextDisplayInput__pZhXE","radioGroup":"editorToolbar-module_radioGroup__q98mq","dropdownSelects":"editorToolbar-module_dropdownSelects__eZ5PX","addButton":"editorToolbar-module_addButton__T-sCA","templateVariable":"editorToolbar-module_templateVariable__mwldh","toolbar":"editorToolbar-module_toolbar__-f8sS"};
styleInject(css_248z$2);

function _slicedToArray$5(arr, i) { return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i) || _unsupportedIterableToArray$6(arr, i) || _nonIterableRest$5(); }
function _nonIterableRest$5() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }
function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$5(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$5(arr) { if (Array.isArray(arr)) return arr; }
var preFormat = function preFormat(editor) {
  return unwrapList(editor);
};
var format = function format(editor, customFormatting) {
  if (editor !== null && editor !== void 0 && editor.selection) {
    var parentEntry = getParentNode(editor, editor.selection);
    if (!parentEntry) return;
    var _parentEntry = _slicedToArray$5(parentEntry, 1),
      node = _parentEntry[0];
    if (isElement(node) && !isType(editor, node, ELEMENT_CODE_BLOCK) && !isType(editor, node, ELEMENT_CODE_LINE)) {
      customFormatting();
    }
  }
};
var formatList = function formatList(editor, elementType) {
  format(editor, function () {
    return toggleList(editor, {
      type: elementType
    });
  });
};
var autoformatPlugin = {
  options: {
    rules: [{
      mode: 'block',
      type: ELEMENT_H1,
      match: '# ',
      preFormat: preFormat
    }, {
      mode: 'block',
      type: ELEMENT_H2,
      match: '## ',
      preFormat: preFormat
    }, {
      mode: 'block',
      type: ELEMENT_LI,
      match: ['* ', '- '],
      preFormat: preFormat,
      format: function format(editor) {
        return formatList(editor, ELEMENT_UL);
      }
    }, {
      mode: 'block',
      type: ELEMENT_LI,
      match: ['1. ', '1) '],
      preFormat: preFormat,
      format: function format(editor) {
        return formatList(editor, ELEMENT_OL);
      }
    }, {
      mode: 'block',
      type: ELEMENT_BLOCKQUOTE,
      match: '> ',
      preFormat: preFormat
    }]
  }
};
var createReplacePlugins = function createReplacePlugins() {
  return [createAutoformatPlugin(autoformatPlugin)];
};

var useMyPlateEditorRef = function useMyPlateEditorRef(id) {
  return usePlateEditorRef(id);
};
var createMyPlugins = function createMyPlugins(plugins, options) {
  return createPlugins(plugins, options);
};

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty$8(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$4(arr, i) { return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$5(arr, i) || _nonIterableRest$4(); }
function _nonIterableRest$4() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }
function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$4(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$4(arr) { if (Array.isArray(arr)) return arr; }
/**
 * If selection in a link or is not url:
 * - insert text with url, exit
 * If selection is expanded or `update` in a link:
 * - remove link node, get link text
 * Then:
 * - insert link node
 */
var upsertLink = function upsertLink(editor, _ref) {
  var _text2, _editor$selection, _text3;
  var url = _ref.url,
    text = _ref.text,
    target = _ref.target,
    insertTextInLink = _ref.insertTextInLink,
    insertNodesOptions = _ref.insertNodesOptions,
    _ref$isUrl = _ref.isUrl,
    isUrl = _ref$isUrl === void 0 ? getPluginOptions(editor, ELEMENT_LINK).isUrl : _ref$isUrl;
  var at = editor === null || editor === void 0 ? void 0 : editor.selection;
  if (!at) return;
  var linkAboveImage = getAboveNode(editor);

  // link above image -> change image by link
  if (linkAboveImage && linkAboveImage[0].type === ELEMENT_IMAGE) {
    var _linkAboveImage$, _linkAboveImage$2;
    if (url !== ((_linkAboveImage$ = linkAboveImage[0]) === null || _linkAboveImage$ === void 0 ? void 0 : _linkAboveImage$.url) || target !== ((_linkAboveImage$2 = linkAboveImage[0]) === null || _linkAboveImage$2 === void 0 ? void 0 : _linkAboveImage$2.target)) {
      var _linkAboveImage$3;
      //removeNodes(editor, { at: editor.selection });
      removeNodes$1(editor, {
        at: editor === null || editor === void 0 ? void 0 : editor.selection
      });
      var _text = {
        text: ''
      };
      insertNodes$1(editor, {
        type: getPluginType$1(editor, ELEMENT_IMAGE_LINK),
        href: url,
        url: (_linkAboveImage$3 = linkAboveImage[0]) === null || _linkAboveImage$3 === void 0 ? void 0 : _linkAboveImage$3.url,
        children: [_text]
      });
    }
    return true;
  }
  var linkAbove = getAboveNode(editor, {
    at: at,
    match: {
      type: getPluginType$1(editor, ELEMENT_LINK)
    }
  });

  // anchor and focus in link -> insert text
  if (insertTextInLink && linkAbove) {
    // we don't want to insert marks in links
    editor.insertText(url);
    return true;
  }
  if (!(isUrl !== null && isUrl !== void 0 && isUrl(url))) return;
  if (isDefined(text) && !text.length) {
    text = url;
  }

  // edit the link url and/or target
  if (linkAbove) {
    var _linkAbove$, _linkAbove$2;
    if (url !== ((_linkAbove$ = linkAbove[0]) === null || _linkAbove$ === void 0 ? void 0 : _linkAbove$.url) || target !== ((_linkAbove$2 = linkAbove[0]) === null || _linkAbove$2 === void 0 ? void 0 : _linkAbove$2.target)) {
      setNodes(editor, {
        url: url,
        target: target
      }, {
        at: linkAbove[1]
      });
    }
    upsertLinkText(editor, {
      url: url,
      text: text,
      target: target
    });
    return true;
  }

  // selection contains at one edge edge or between the edges
  var linkEntry = findNode(editor, {
    at: at,
    match: {
      type: getPluginType$1(editor, ELEMENT_LINK)
    }
  });
  var _ref2 = linkEntry !== null && linkEntry !== void 0 ? linkEntry : [],
    _ref3 = _slicedToArray$4(_ref2, 2),
    linkNode = _ref3[0],
    linkPath = _ref3[1];
  var shouldReplaceText = false;
  if (linkPath && (_text2 = text) !== null && _text2 !== void 0 && _text2.length) {
    var linkText = getEditorString(editor, linkPath);
    if (text !== linkText) {
      shouldReplaceText = true;
    }
  }
  var linkEntryImg = findNode(editor, {
    at: at,
    match: {
      type: getPluginType$1(editor, ELEMENT_IMAGE)
    }
  });
  if (isExpanded(at) || linkEntryImg) {
    // anchor and focus in link
    if (linkAbove) {
      unwrapLink(editor, {
        at: linkAbove[1]
      });
    } else {
      unwrapLink(editor, {
        split: true
      });
    }
    wrapLink(editor, {
      url: url,
      target: target
    });
    upsertLinkText(editor, {
      url: url,
      target: target,
      text: text
    });
    return true;
  }
  if (shouldReplaceText) {
    removeNodes$1(editor, {
      at: linkPath
    });
  }
  var props = getNodeProps(linkNode !== null && linkNode !== void 0 ? linkNode : {});
  var path = (_editor$selection = editor.selection) === null || _editor$selection === void 0 ? void 0 : _editor$selection.focus.path;
  if (!path) return;

  // link text should have the focused leaf marks
  var leaf = getNodeLeaf(editor, path);

  // if text is empty, text is url
  if (!((_text3 = text) !== null && _text3 !== void 0 && _text3.length)) {
    text = url;
  }
  insertLink(editor, _objectSpread$7(_objectSpread$7({}, props), {}, {
    url: url,
    target: target,
    children: [_objectSpread$7(_objectSpread$7({}, leaf), {}, {
      text: text
    })]
  }), insertNodesOptions);
  return true;
};

/**
 * Insert link if url is valid.
 * Text is url if empty.
 * Close floating link.
 * Focus editor.
 */
var submitFloatingLink = function submitFloatingLink(editor) {
  if (!(editor !== null && editor !== void 0 && editor.selection)) return;
  var _getPluginOptions = getPluginOptions(editor, ELEMENT_LINK),
    _isUrl = _getPluginOptions.isUrl,
    forceSubmit = _getPluginOptions.forceSubmit;
  var url = floatingLinkSelectors.url();
  var isValid = (_isUrl === null || _isUrl === void 0 ? void 0 : _isUrl(url)) || forceSubmit;
  if (!isValid) return;
  var text = floatingLinkSelectors.text();
  var target = floatingLinkSelectors.newTab() ? undefined : '_self';
  floatingLinkActions.hide();
  upsertLink(editor, {
    url: url,
    text: text,
    target: target,
    isUrl: function isUrl(_url) {
      return forceSubmit || !_isUrl ? true : _isUrl(_url);
    }
  });
  setTimeout(function () {
    focusEditor(editor, editor.selection);
  }, 0);
  return true;
};

var useFloatingLinkEnter = function useFloatingLinkEnter() {
  var editor = useEditorRef();
  var open = useFloatingLinkSelectors().isOpen(editor.id);
  useHotkeys('*', function (e) {
    if (e.key !== 'Enter') return;
    if (submitFloatingLink(editor)) {
      e.preventDefault();
    }
  }, {
    enabled: open,
    //@ts-ignore
    enableOnFormTags: ['INPUT']
  }, []);
};

var _excluded$3 = ["floatingOptions"];
function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty$7(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$3(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$4(arr, i) || _nonIterableRest$3(); }
function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }
function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$3(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties$3(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$3(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useFloatingLinkEdit = function useFloatingLinkEdit(_ref) {
  var floatingOptions = _ref.floatingOptions,
    props = _objectWithoutProperties$3(_ref, _excluded$3);
  var editor = useEditorRef();
  var keyEditor = usePlateSelectors().keyEditor();
  var mode = useFloatingLinkSelectors().mode();
  var open = useFloatingLinkSelectors().isOpen(editor.id);
  var _getPluginOptions = getPluginOptions(editor, ELEMENT_LINK),
    triggerFloatingLinkHotkeys = _getPluginOptions.triggerFloatingLinkHotkeys;
  var getBoundingClientRect = useCallback(function () {
    var entry = getAboveNode(editor, {
      match: {
        type: getPluginType$1(editor, ELEMENT_LINK)
      }
    });
    if (entry) {
      var _entry = _slicedToArray$3(entry, 2),
        path = _entry[1];
      return getRangeBoundingClientRect(editor, {
        anchor: getStartPoint(editor, path),
        focus: getEndPoint(editor, path)
      });
    }
    return getDefaultBoundingClientRect();
  }, [editor]);
  var isOpen = open && mode === 'edit';
  var _useVirtualFloatingLi = useVirtualFloatingLink(_objectSpread$6({
      editorId: editor.id,
      open: isOpen,
      getBoundingClientRect: getBoundingClientRect
    }, floatingOptions)),
    update = _useVirtualFloatingLi.update,
    style = _useVirtualFloatingLi.style,
    floating = _useVirtualFloatingLi.floating;
  useEffect(function () {
    if (editor !== null && editor !== void 0 && editor.selection && someNode(editor, {
      match: {
        type: getPluginType$1(editor, ELEMENT_LINK)
      }
    })) {
      floatingLinkActions.show('edit', editor.id);
      update();
      return;
    }
    if (floatingLinkSelectors.mode() === 'edit') {
      floatingLinkActions.hide();
    }
  }, [editor, keyEditor, update]);
  useHotkeys(triggerFloatingLinkHotkeys, function (e) {
    if (floatingLinkSelectors.mode() === 'edit' && triggerFloatingLinkEdit(editor)) {
      e.preventDefault();
    }
  }, {
    enableOnContentEditable: true
  }, []);
  useFloatingLinkEnter();
  useFloatingLinkEscape();
  return _objectSpread$6(_objectSpread$6({
    style: _objectSpread$6(_objectSpread$6({}, style), {}, {
      zIndex: 1
    })
  }, props), {}, {
    ref: useComposedRef(props.ref, floating)
  });
};

var _excluded$2 = ["floatingOptions"];
function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty$6(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useFloatingLinkInsert = function useFloatingLinkInsert(_ref) {
  var floatingOptions = _ref.floatingOptions,
    props = _objectWithoutProperties$2(_ref, _excluded$2);
  var editor = useEditorRef$1();
  var focused = useFocused();
  var mode = useFloatingLinkSelectors().mode();
  var open = useFloatingLinkSelectors().isOpen(editor.id);
  var _getPluginOptions = getPluginOptions$1(editor, ELEMENT_LINK),
    triggerFloatingLinkHotkeys = _getPluginOptions.triggerFloatingLinkHotkeys;
  useHotkeys$1(triggerFloatingLinkHotkeys, function (e) {
    if (triggerFloatingLinkInsert(editor, {
      focused: focused
    })) {
      e.preventDefault();
    }
  }, {
    enableOnContentEditable: true
  }, [focused]);
  var ref = useOnClickOutside(function () {
    if (floatingLinkSelectors.mode() === 'insert') {
      submitFloatingLink(editor);
    }
  }, {
    disabled: !open
  });
  var _useVirtualFloatingLi = useVirtualFloatingLink(_objectSpread$5({
      editorId: editor.id,
      open: open && mode === 'insert',
      getBoundingClientRect: getSelectionBoundingClientRect,
      whileElementsMounted: function whileElementsMounted() {}
    }, floatingOptions)),
    update = _useVirtualFloatingLi.update,
    style = _useVirtualFloatingLi.style,
    floating = _useVirtualFloatingLi.floating;

  // wait for update before focusing input
  useEffect(function () {
    if (open) {
      update();
      floatingLinkActions.updated(true);
    } else {
      floatingLinkActions.updated(false);
    }
  }, [open, update]);
  useFloatingLinkEscape();
  return _objectSpread$5(_objectSpread$5({
    style: _objectSpread$5(_objectSpread$5({}, style), {}, {
      zIndex: 1
    })
  }, props), {}, {
    ref: useComposedRef$1(props.ref, floating, ref)
  });
};

var FloatingLinkEditRoot = createComponentAs(function (props) {
  var _htmlProps$style;
  var htmlProps = useFloatingLinkEdit(props);
  if (((_htmlProps$style = htmlProps.style) === null || _htmlProps$style === void 0 ? void 0 : _htmlProps$style.display) === 'none') {
    return null;
  }
  return createElementAs$1('div', htmlProps);
});
var FloatingLinkInsertRoot = createComponentAs(function (props) {
  var _htmlProps$style2;
  var htmlProps = useFloatingLinkInsert(props);
  if (((_htmlProps$style2 = htmlProps.style) === null || _htmlProps$style2 === void 0 ? void 0 : _htmlProps$style2.display) === 'none') {
    return null;
  }
  return createElementAs$1('div', htmlProps);
});
var FloatingLink = {
  EditRoot: FloatingLinkEditRoot,
  InsertRoot: FloatingLinkInsertRoot,
  UrlInput: FloatingLinkUrlInput,
  TextInput: FloatingLinkTextInput,
  NewTabInput: FloatingLinkNewTabInput,
  EditButton: FloatingLinkEditButton,
  UnlinkButton: UnlinkButton,
  OpenLinkButton: OpenLinkButton
};

var css_248z$1 = ".PlateFloatingLink-module_container__puXtn {\n  display: flex;\n  flex-direction: column;\n  width: 300px;\n}\n\n.PlateFloatingLink-module_line__Kpn7h {\n  height: 1px;\n  --tw-bg-opacity: 1;\n  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));\n}\n\n.PlateFloatingLink-module_floatingButtonCss__mza38 {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.625rem;\n  padding-right: 0.625rem;\n\n  display: inline-flex;\n  position: relative;\n  padding: 0;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  max-width: 100%;\n  background-color: #ffffff;\n  font-weight: 500;\n  border-width: 0;\n  cursor: pointer;\n\n  font-family: inherit;\n  font-size: 14px;\n  border-radius: 3px;\n  color: inherit;\n}\n\n.PlateFloatingLink-module_floatingButtonCss__mza38:active,\n.PlateFloatingLink-module_floatingButtonCss__mza38:hover {\n  background-color: #e5e7eb;\n}\n\n.PlateFloatingLink-module_floatingButtonCss__mza38:active {\n  color: inherit;\n}\n\n.PlateFloatingLink-module_floatingButtonCss__mza38:visited {\n  color: inherit;\n}\n\n.PlateFloatingLink-module_floatingInputCss__OKkF2 {\n  padding: 0;\n  background-color: transparent;\n  flex-grow: 1;\n  height: 2rem;\n  border-style: none;\n  line-height: 20px;\n}\n\n.PlateFloatingLink-module_floatingInputCss__OKkF2:focus {\n  outline: none;\n}\n\n.PlateFloatingLink-module_plateButtonCss__NZHiz {\n  display: inline-flex;\n  position: relative;\n  padding: 0;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  max-width: 100%;\n\n  font-weight: 500;\n  border-width: 0;\n  cursor: pointer;\n\n  background-color: #ffffff;\n\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.625rem;\n  padding-right: 0.625rem;\n\n  font-family: inherit;\n  font-size: 14px;\n  border-radius: 3px;\n\n  color: inherit;\n}\n\n.PlateFloatingLink-module_plateButtonCss__NZHiz:active,\n.PlateFloatingLink-module_plateButtonCss__NZHiz:hover {\n  background-color: #e5e7eb;\n}\n\n.PlateFloatingLink-module_plateButtonCss__NZHiz:active {\n  color: inherit;\n}\n\n.PlateFloatingLink-module_plateButtonCss__NZHiz:visited {\n  color: inherit;\n}\n\n.PlateFloatingLink-module_floatingRootCss__ZvmHh {\n  background-color: #ffffff;\n  z-index: 20 !important;\n  width: auto;\n  border-radius: 4px;\n  box-shadow: rgb(15 15 15 / 5%) 0 0 0 1px, rgb(15 15 15 / 10%) 0 3px 6px,\n    rgb(15 15 15 / 20%) 0 9px 24px;\n}\n\n.PlateFloatingLink-module_floatingRowCss__e1mwP {\n  display: flex;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  flex-direction: row;\n  align-items: center;\n}\n";
var styles$1 = {"container":"PlateFloatingLink-module_container__puXtn","line":"PlateFloatingLink-module_line__Kpn7h","floatingButtonCss":"PlateFloatingLink-module_floatingButtonCss__mza38","floatingInputCss":"PlateFloatingLink-module_floatingInputCss__OKkF2","plateButtonCss":"PlateFloatingLink-module_plateButtonCss__NZHiz","floatingRootCss":"PlateFloatingLink-module_floatingRootCss__ZvmHh","floatingRowCss":"PlateFloatingLink-module_floatingRowCss__e1mwP"};
styleInject(css_248z$1);

var PlateFloatingLink = function PlateFloatingLink(_ref) {
  var readOnly = _ref.readOnly;
  var isEditing = useFloatingLinkSelectors$1().isEditing();
  var editor = useEditorRef();
  var linkAbove = getAboveNode(editor);
  if (readOnly) return null;
  var input = /*#__PURE__*/jsxs("div", {
    className: styles$1.container,
    children: [/*#__PURE__*/jsxs(FloatingInputWrapper, {
      children: [/*#__PURE__*/jsx(FloatingIconWrapper, {
        children: /*#__PURE__*/jsx(LinkIcon, {
          width: 18
        })
      }), /*#__PURE__*/jsx(FloatingLink.UrlInput, {
        className: styles$1.floatingInputCss,
        placeholder: "Paste link"
      })]
    }), /*#__PURE__*/jsx("div", {
      className: styles$1.line
    }), (linkAbove === null || linkAbove === void 0 ? void 0 : linkAbove[0].type) !== ELEMENT_IMAGE && /*#__PURE__*/jsxs(FloatingInputWrapper, {
      children: [/*#__PURE__*/jsx(FloatingIconWrapper, {
        children: /*#__PURE__*/jsx(ShortTextIcon, {
          width: 18
        })
      }), /*#__PURE__*/jsx(FloatingLink.TextInput, {
        className: styles$1.floatingInputCss,
        placeholder: "Text to display"
      })]
    })]
  });
  var editContent = !isEditing ? /*#__PURE__*/jsxs("div", {
    className: styles$1.floatingRowCss,
    children: [/*#__PURE__*/jsx(FloatingLink.EditButton, {
      className: styles$1.plateButtonCss,
      children: "Edit link"
    }), /*#__PURE__*/jsx(FloatingVerticalDivider, {}), /*#__PURE__*/jsx(FloatingLink.OpenLinkButton, {
      className: styles$1.floatingButtonCss,
      children: /*#__PURE__*/jsx(LaunchIcon, {
        width: 18
      })
    }), /*#__PURE__*/jsx(FloatingVerticalDivider, {}), /*#__PURE__*/jsx(FloatingLink.UnlinkButton, {
      className: styles$1.floatingButtonCss,
      children: /*#__PURE__*/jsx(LinkOffIcon, {
        width: 18
      })
    })]
  }) : input;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(FloatingLink.InsertRoot, {
      className: styles$1.floatingRootCss,
      children: input
    }), /*#__PURE__*/jsx(FloatingLink.EditRoot, {
      className: styles$1.floatingRootCss,
      children: editContent
    })]
  });
};

var linkPlugin = {
  renderAfterEditable: PlateFloatingLink,
  options: {
    isUrl: function isUrl() {
      return true;
    },
    forceSubmit: true
  }
};
var createElementsPlugins = function createElementsPlugins() {
  return createMyPlugins([createBlockquotePlugin(), createHeadingPlugin(), createLinkPlugin(linkPlugin), createListPlugin()]);
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty$5(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var resetBlockTypesCommonRule = {
  types: [ELEMENT_BLOCKQUOTE],
  defaultType: ELEMENT_PARAGRAPH$1
};
var resetBlockTypePlugin = {
  options: {
    rules: [_objectSpread$4(_objectSpread$4({}, resetBlockTypesCommonRule), {}, {
      hotkey: 'Enter',
      predicate: isBlockAboveEmpty
    }), _objectSpread$4(_objectSpread$4({}, resetBlockTypesCommonRule), {}, {
      hotkey: 'Backspace',
      predicate: isSelectionAtBlockStart
    })]
  }
};
var exitBreakPlugin = {
  options: {
    rules: [{
      hotkey: 'mod+enter'
    }, {
      hotkey: 'mod+shift+enter',
      before: true
    }, {
      hotkey: 'enter',
      query: {
        start: true,
        end: true,
        allow: KEYS_HEADING
      },
      relative: true
    }, {
      hotkey: 'enter',
      query: {
        allow: [ELEMENT_IMAGE, ELEMENT_BLOCKQUOTE, ELEMENT_IMAGE_LINK]
      }
    }, {
      hotkey: 'enter',
      before: true,
      query: {
        start: true,
        allow: [ELEMENT_PARAGRAPH$1]
      }
    }]
  }
};
var selectOnBackspacePlugin = {
  options: {
    query: {
      allow: [ELEMENT_IMAGE, ELEMENT_TEMPLATE_VARIABLE, ELEMENT_MISSING_VARIABLE, ELEMENT_RAW_HTML_BLOCK, ELEMENT_IMAGE_LINK]
    }
  }
};
var createControlPlugins = function createControlPlugins() {
  return createMyPlugins([
  //createResetNodePlugin(resetBlockTypePlugin),
  createExitBreakPlugin(exitBreakPlugin), createSelectOnBackspacePlugin(selectOnBackspacePlugin)]);
};

var insertImage = function insertImage(editor, url) {
  var text = {
    text: ''
  };
  var image = {
    type: getPluginType$1(editor, ELEMENT_IMAGE),
    url: url,
    width: 300,
    children: [text]
  };
  insertNodes$1(editor, image);
  setTimeout(function () {
    var path = findNodePath(editor, image);
    select$1(editor, getPointAfter(editor, path));
    focusEditor(editor);
  }, 500);
};

/**
 * If inserted text is image url, insert image instead.
 */
var withImageEmbed = function withImageEmbed(editor, plugin) {
  var insertData = editor.insertData;
  editor.insertData = function (dataTransfer) {
    var text = dataTransfer.getData('text/plain');
    if (isImageUrl(text)) {
      insertImage(editor, text);
      return;
    }
    insertData(dataTransfer);
  };
  return editor;
};

function _typeof$1(obj) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$1(obj); }
function _regeneratorRuntime$1() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime$1 = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof$1(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator$1(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest$2(); }
function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit$2(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }
function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Allows for pasting images from clipboard.
 * Not yet: dragging and dropping images, selecting them through a file system dialog.
 */
var withImageUpload = function withImageUpload(editor, plugin) {
  plugin.options.uploadImage;
  var insertData = editor.insertData;
  editor.insertData = function (dataTransfer) {
    var text = dataTransfer.getData('text/plain');
    var files = dataTransfer.files;
    if (files && files.length > 0) {
      var injectedPlugins = getInjectedPlugins(editor, plugin);
      if (!pipeInsertDataQuery(injectedPlugins, {
        data: text,
        dataTransfer: dataTransfer
      })) {
        return insertData(dataTransfer);
      }
      //@ts-ignore
      var _iterator = _createForOfIteratorHelper(files),
        _step;
      try {
        var _loop = function _loop() {
          var file = _step.value;
          var reader = new FileReader();
          var _file$type$split = file.type.split('/'),
            _file$type$split2 = _slicedToArray$2(_file$type$split, 1),
            mime = _file$type$split2[0];
          if (mime === 'image') {
            reader.addEventListener('load', /*#__PURE__*/_asyncToGenerator$1( /*#__PURE__*/_regeneratorRuntime$1().mark(function _callee() {
              var formData, response;
              return _regeneratorRuntime$1().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (reader.result) {
                        _context.next = 2;
                        break;
                      }
                      return _context.abrupt("return");
                    case 2:
                      formData = new FormData();
                      formData.append('file', file);
                      formData.append('visible', 'true');
                      _context.next = 7;
                      return api.post('/messaging/mediaFiles', formData, {
                        validateStatus: function validateStatus() {
                          return true;
                        },
                        headers: {
                          'Content-Type': 'multipart/form-data'
                        }
                      });
                    case 7:
                      response = _context.sent;
                      if (response.status === 201) {
                        insertImage(editor, response.data.url);
                      }
                    case 9:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })));
            reader.readAsDataURL(file);
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else {
      insertData(dataTransfer);
    }
  };
  return editor;
};

/**
 * @see withImageUpload
 * @see withImageEmbed
 */
var withImage = function withImage(editor, plugin) {
  var _plugin$options = plugin.options,
    disableUploadInsert = _plugin$options.disableUploadInsert,
    disableEmbedInsert = _plugin$options.disableEmbedInsert;
  if (!disableUploadInsert) {
    editor = withImageUpload(editor, plugin);
  }
  if (!disableEmbedInsert) {
    editor = withImageEmbed(editor);
  }
  return editor;
};

var createImagePlugin = createPluginFactory({
  key: ELEMENT_IMAGE,
  isElement: true,
  isVoid: true,
  withOverrides: withImage,
  options: {
    disableCaption: true
  },
  plugins: [{
    key: ELEMENT_IMAGE_LINK,
    isElement: true,
    isVoid: true,
    then: function then(editor, _ref) {
      var type = _ref.type;
      return {
        deserializeHtml: {
          rules: [{
            validNodeName: 'IMGLINK'
          }],
          getNode: function getNode(el) {
            return {
              type: type,
              url: el.getAttribute('src'),
              href: el.getAttribute('href')
            };
          }
        },
        serializeHtml: function serializeHtml(_ref2) {
          var element = _ref2.element;
          var width = element.width;
          return /*#__PURE__*/jsx("a", {
            rel: "noreferrer noopener",
            target: "_blank",
            href: element.href,
            children: /*#__PURE__*/jsx("img", {
              src: element.url,
              alt: "",
              style: {
                width: typeof width === 'string' || typeof width === 'number' ? width : undefined,
                marginTop: 8
              }
            })
          });
        }
      };
    }
  }],
  then: function then(_, _ref3) {
    var type = _ref3.type;
    return {
      deserializeHtml: {
        rules: [{
          validNodeName: 'IMG'
        }],
        getNode: function getNode(el) {
          return {
            type: type,
            url: el.getAttribute('src')
          };
        }
      },
      serializeHtml: function serializeHtml(_ref4) {
        var element = _ref4.element;
        var width = element.width;
        return /*#__PURE__*/jsx("img", {
          src: element.url,
          alt: "",
          style: {
            width: typeof width === 'string' || typeof width === 'number' ? width : undefined,
            marginTop: 8
          }
        });
      }
    };
  }
});

var insertImageLink = function insertImageLink(editor, url, href) {
  var text = {
    text: ''
  };
  var image = {
    type: getPluginType(editor, ELEMENT_IMAGE_LINK),
    url: url,
    href: href,
    children: [text]
  };
  insertNodes(editor, image);
};

var _excluded$1 = ["id", "type", "clear"];
function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty$4(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var MarkToolbarButton = function MarkToolbarButton(_ref) {
  var id = _ref.id,
    type = _ref.type,
    clear = _ref.clear,
    props = _objectWithoutProperties$1(_ref, _excluded$1);
  var editor = usePlateEditorState(useEventPlateId(id));
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsx(ToolbarButton, _objectSpread$3({
      active: !!(editor !== null && editor !== void 0 && editor.selection) && isMarkActive(editor, type),
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleMark(editor, {
          key: type,
          clear: clear
        });
        focusEditor$1(editor);
      }
    }, props))
  });
};

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty$3(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$1(); }
function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }
function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }
function _regeneratorRuntime() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var EditorToolbar = function EditorToolbar(_ref) {
  var children = _ref.children,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'bloobirds' : _ref$backgroundColor,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var isLinkedinPage = window.location.href.includes('linkedin');
  return /*#__PURE__*/jsx(Toolbar, {
    disabled: disabled,
    backgroundColor: backgroundColor,
    className: isLinkedinPage && styles$2.toolbar,
    children: children
  });
};
var EditorToolbarControlsSection = function EditorToolbarControlsSection(_ref2) {
  var color = _ref2.color;
  var editor = useMyPlateEditorRef(useEventPlateId());
  return /*#__PURE__*/jsxs(ToolbarSection, {
    children: [/*#__PURE__*/jsx(ToolbarButton, {
      icon: "undoRevert",
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        editor.undo();
        focusEditor$1(editor);
      },
      color: color
    }), /*#__PURE__*/jsx(ToolbarButton, {
      icon: "redoReload",
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        editor.redo();
        focusEditor$1(editor);
      },
      color: color
    })]
  });
};
var EditorToolbarFontStylesSection = function EditorToolbarFontStylesSection(_ref3) {
  var color = _ref3.color;
  var editor = useMyPlateEditorRef(useEventPlateId());
  var hasSelection = !!(editor !== null && editor !== void 0 && editor.selection);
  return /*#__PURE__*/jsxs(ToolbarSection, {
    children: [/*#__PURE__*/jsx(ToolbarButton, {
      icon: "header1",
      active: hasSelection && someNode$1(editor, {
        match: {
          type: ELEMENT_H1
        }
      }),
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleNodeType(editor, {
          activeType: ELEMENT_H1
        });
        focusEditor$1(editor);
      },
      color: color || 'white'
    }), /*#__PURE__*/jsx(ToolbarButton, {
      icon: "header2",
      active: hasSelection && someNode$1(editor, {
        match: {
          type: ELEMENT_H2
        }
      }),
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleNodeType(editor, {
          activeType: ELEMENT_H2
        });
        focusEditor$1(editor);
      },
      color: color || 'white'
    }), /*#__PURE__*/jsx(ToolbarButton, {
      icon: "quote",
      active: hasSelection && someNode$1(editor, {
        match: {
          type: ELEMENT_BLOCKQUOTE
        }
      }),
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleNodeType(editor, {
          activeType: ELEMENT_BLOCKQUOTE
        });
        focusEditor$1(editor);
      },
      color: color || 'white'
    })]
  });
};
var EditorToolbarLink = function EditorToolbarLink(_ref4) {
  var color = _ref4.color;
  var editor = useMyPlateEditorRef(useEventPlateId());
  var type = getPluginType(editor, ELEMENT_LINK);
  var hasSelection = !!(editor !== null && editor !== void 0 && editor.selection);
  return /*#__PURE__*/jsx(ToolbarButton, {
    icon: "link",
    color: color || 'white',
    active: hasSelection && someNode$1(editor, {
      match: {
        type: type
      }
    }),
    onMouseDown: /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        var _editor$selection;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (editor) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                event.preventDefault();
                event.stopPropagation();
                focusEditor$1(editor, (_editor$selection = editor.selection) !== null && _editor$selection !== void 0 ? _editor$selection : editor.prevSelection);
                setTimeout(function () {
                  triggerFloatingLink(editor, {
                    focused: true
                  });
                }, 0);
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }()
  });
};
var EditorToolbarSnippet = function EditorToolbarSnippet(_ref6) {
  var onClick = _ref6.onClick;
  var editor = useMyPlateEditorRef(useEventPlateId());
  return /*#__PURE__*/jsx(ToolbarButton, {
    icon: "snippet",
    color: "white",
    onMouseDown: /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        var _editor$selection2;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (editor) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                onClick === null || onClick === void 0 ? void 0 : onClick();
                event.preventDefault();
                event.stopPropagation();
                focusEditor$1(editor, (_editor$selection2 = editor.selection) !== null && _editor$selection2 !== void 0 ? _editor$selection2 : editor.prevSelection);
              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref7.apply(this, arguments);
      };
    }()
  });
};
var EditorToolbarTextMarksSection = function EditorToolbarTextMarksSection(_ref8) {
  var color = _ref8.color;
  var editor = useMyPlateEditorRef();
  return /*#__PURE__*/jsxs(ToolbarSection, {
    children: [/*#__PURE__*/jsx(MarkToolbarButton, {
      type: getPluginType(editor, MARK_BOLD),
      icon: "textBold",
      color: color || 'white',
      actionHandler: "onMouseDown"
    }), /*#__PURE__*/jsx(MarkToolbarButton, {
      type: getPluginType(editor, MARK_ITALIC),
      icon: "textItalic",
      color: color || 'white',
      actionHandler: "onMouseDown"
    }), /*#__PURE__*/jsx(MarkToolbarButton, {
      type: getPluginType(editor, MARK_UNDERLINE),
      icon: "textUnderlined",
      color: color || 'white',
      actionHandler: "onMouseDown"
    }), /*#__PURE__*/jsx(EditorToolbarLink, {
      color: color
    })]
  });
};
var EditorToolbarListsSection = function EditorToolbarListsSection(_ref9) {
  var color = _ref9.color;
  var editor = useMyPlateEditorRef(useEventPlateId());
  var hasSelection = !!(editor !== null && editor !== void 0 && editor.selection);
  return /*#__PURE__*/jsxs(ToolbarSection, {
    children: [/*#__PURE__*/jsx(ToolbarButton, {
      icon: "textBulletList",
      color: color || 'white',
      active: hasSelection && someNode$1(editor, {
        match: {
          type: ELEMENT_UL
        }
      }),
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleList(editor, {
          type: ELEMENT_UL
        });
        focusEditor$1(editor);
      }
    }), /*#__PURE__*/jsx(ToolbarButton, {
      icon: "textOrderedList",
      color: color || 'white',
      active: hasSelection && someNode$1(editor, {
        match: {
          type: ELEMENT_OL
        }
      }),
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleList(editor, {
          type: ELEMENT_OL
        });
        focusEditor$1(editor);
      }
    })]
  });
};
var EditorToolbarSection = function EditorToolbarSection(_ref10) {
  var children = _ref10.children;
  return /*#__PURE__*/jsx(ToolbarSection, {
    children: children
  });
};
var EditorToolbarImage = function EditorToolbarImage(_ref11) {
  var _ref11$color = _ref11.color,
    color = _ref11$color === void 0 ? 'white' : _ref11$color;
  var eventPlateId = useEventPlateId();
  var editor = useMyPlateEditorRef(eventPlateId);
  var lastSelection = useRef(null);
  var _useToasts = useToasts(),
    createToast = _useToasts.createToast;
  useEffect(function () {
    var handleSelectionChange = function handleSelectionChange() {
      if (editor !== null && editor !== void 0 && editor.selection) {
        lastSelection.current = editor.selection;
      }
    };
    document.addEventListener('selectionchange', handleSelectionChange);
    return function () {
      return document.removeEventListener('selectionchange', handleSelectionChange);
    };
  }, [editor]);
  var addImage = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(event) {
      var _response$data;
      var file, formData, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              file = event.target.files[0];
              if (!(!file || !file.type.startsWith('image/'))) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              formData = new FormData();
              formData.append('file', file);
              formData.append('visible', 'true');
              _context3.next = 8;
              return api.post('/messaging/mediaFiles', formData, {
                validateStatus: function validateStatus() {
                  return true;
                },
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              });
            case 8:
              response = _context3.sent;
              if (response.status === 201) {
                if (lastSelection.current) {
                  select(editor, lastSelection.current);
                }
                insertImage(editor, response.data.url);
              } else if (response.status === 500 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.message.includes('SizeLimitExceededException')) {
                createToast({
                  message: "File exceeds maximum allowed size of 15MB",
                  type: 'error'
                });
              } else {
                createToast({
                  message: 'Failed to upload attachment',
                  type: 'error'
                });
              }
            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function addImage(_x3) {
      return _ref12.apply(this, arguments);
    };
  }();

  // This allows selecting the same image twice
  var resetSelectedImage = function resetSelectedImage(event) {
    event.target.value = null;
  };
  return /*#__PURE__*/jsxs("label", {
    className: styles$2.label,
    htmlFor: "insert-image",
    children: [/*#__PURE__*/jsx(Icon, {
      name: "image",
      size: 20,
      color: color
    }), /*#__PURE__*/jsx("input", {
      type: "file",
      id: "insert-image",
      name: "insert-image",
      "data-test": "insert-image",
      onClick: resetSelectedImage,
      onChange: addImage,
      className: styles$2.input,
      accept: ".png, .jpeg, .gif, .jpg",
      multiple: false
    })]
  });
};
var TemplateEditorToolbarImage = function TemplateEditorToolbarImage(_ref13) {
  var _ref13$color = _ref13.color,
    color = _ref13$color === void 0 ? 'white' : _ref13$color;
  var eventPlateId = useEventPlateId();
  var editor = useMyPlateEditorRef(eventPlateId);
  var lastSelection = useRef(null);
  var _useToasts2 = useToasts(),
    createToast = _useToasts2.createToast;
  useEffect(function () {
    var handleSelectionChange = function handleSelectionChange() {
      if (editor !== null && editor !== void 0 && editor.selection) {
        lastSelection.current = editor.selection;
      }
    };
    document.addEventListener('selectionchange', handleSelectionChange);
    return function () {
      return document.removeEventListener('selectionchange', handleSelectionChange);
    };
  }, [editor]);
  var addImage = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(event) {
      var _response$data2;
      var file, formData, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              file = event.target.files[0];
              if (!(!file || !file.type.startsWith('image/'))) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return");
            case 3:
              formData = new FormData();
              formData.append('file', file);
              formData.append('visible', 'true');
              _context4.next = 8;
              return api.post('/messaging/mediaFiles', formData, {
                validateStatus: function validateStatus() {
                  return true;
                },
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              });
            case 8:
              response = _context4.sent;
              if (response.status === 201) {
                if (lastSelection !== null && lastSelection !== void 0 && lastSelection.current) {
                  select(editor, lastSelection.current);
                }
                insertImage(editor, response.data.url);
              } else if (response.status === 500 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.message.includes('SizeLimitExceededException')) {
                createToast({
                  message: "File exceeds maximum allowed size of 15MB",
                  type: 'error'
                });
              } else {
                createToast({
                  message: 'Failed to upload attachment',
                  type: 'error'
                });
              }
            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function addImage(_x4) {
      return _ref14.apply(this, arguments);
    };
  }();

  // This allows selecting the same image twice
  var resetSelectedImage = function resetSelectedImage(event) {
    event.target.value = null;
  };
  return /*#__PURE__*/jsxs("label", {
    className: styles$2.label,
    htmlFor: "insert-image-2",
    children: [/*#__PURE__*/jsx(Icon, {
      name: "image",
      size: 20,
      color: color
    }), /*#__PURE__*/jsx("input", {
      type: "file",
      id: "insert-image-2",
      name: "insert-image-2",
      "data-test": "insert-image-2",
      onClick: function onClick(event) {
        return resetSelectedImage(event);
      },
      onChange: addImage,
      className: styles$2.input,
      accept: ".png, .jpeg, .gif, .jpg",
      multiple: false
    })]
  });
};
var EditorToolbarFileAttachment = function EditorToolbarFileAttachment(_ref15) {
  var _ref15$color = _ref15.color,
    color = _ref15$color === void 0 ? 'white' : _ref15$color,
    onAttachment = _ref15.onAttachment;
  return /*#__PURE__*/jsxs("label", {
    className: styles$2.label,
    htmlFor: "file-attachment",
    children: [/*#__PURE__*/jsx(Icon, {
      name: "paperclip",
      size: 20,
      color: color
    }), /*#__PURE__*/jsx("input", {
      type: "file",
      id: "file-attachment",
      name: "file-attachment",
      "data-test": "file-attachment",
      onChange: function onChange(event) {
        onAttachment(Array.from(event.target.files));
        event.target.value = null;
      },
      className: styles$2.input,
      multiple: true
    })]
  });
};
var TemplateEditorToolbarFileAttachment = function TemplateEditorToolbarFileAttachment(_ref16) {
  var _ref16$color = _ref16.color,
    color = _ref16$color === void 0 ? 'white' : _ref16$color,
    onAttachment = _ref16.onAttachment;
  return /*#__PURE__*/jsxs("label", {
    className: styles$2.label,
    htmlFor: "file-attachment-2",
    children: [/*#__PURE__*/jsx(Icon, {
      name: "paperclip",
      size: 20,
      color: color
    }), /*#__PURE__*/jsx("input", {
      type: "file",
      id: "file-attachment-2",
      name: "file-attachment-2",
      "data-test": "file-attachment-2",
      onChange: function onChange(event) {
        onAttachment(Array.from(event.target.files));
        event.target.value = null;
      },
      className: styles$2.input,
      multiple: true
    })]
  });
};
var EditorToolbarTemplateVariable = function EditorToolbarTemplateVariable(_ref17) {
  var _ref17$disableEmpty = _ref17.disableEmpty,
    disableEmpty = _ref17$disableEmpty === void 0 ? false : _ref17$disableEmpty;
  var editor = useMyPlateEditorRef(useEventPlateId());
  var _useVisible = useVisible(false),
    ref = _useVisible.ref,
    visible = _useVisible.visible,
    setVisible = _useVisible.setVisible;
  var emailVariables = useBaseEmailVariables();
  var emailValues = useBaseEmailVariableValue();
  var isDisableVariable = function isDisableVariable(group, variable) {
    var _emailValues$group;
    return disableEmpty && !((_emailValues$group = emailValues[group]) !== null && _emailValues$group !== void 0 && _emailValues$group.find(function (value) {
      return variable.id === value.id;
    }).value);
  };
  return /*#__PURE__*/jsx("div", {
    className: styles$2.templateVariable,
    children: /*#__PURE__*/jsx(ToolbarMenu, {
      ref: ref,
      icon: "textVariable",
      width: 200,
      visible: visible
      // @ts-ignore
      ,
      onClick: function onClick(event) {
        event.preventDefault();
        event.stopPropagation();
        setVisible(!visible);
      },
      children: /*#__PURE__*/jsx("div", {
        className: styles$2.variableList,
        children: emailVariables && Object.entries(emailVariables).map(function (_ref18) {
          var _ref19 = _slicedToArray$1(_ref18, 2),
            group = _ref19[0],
            variables = _ref19[1];
          return /*#__PURE__*/jsxs(Fragment$1, {
            children: [/*#__PURE__*/jsx(Section, {
              children: toTitleCase(group)
            }), variables.map(function (variable) {
              return /*#__PURE__*/jsx(Item, {
                disabled: isDisableVariable(group, variable),
                onMouseDown: function onMouseDown(event) {
                  if (!isDisableVariable(group, variable)) {
                    event.preventDefault();
                    event.stopPropagation();
                    insertTemplateVariable(editor, {
                      id: variable.id,
                      name: variable.name,
                      group: variable.type
                    });
                    setVisible(false);
                  }
                },
                children: variable.name
              }, variable.id);
            })]
          }, group);
        })
      })
    })
  });
};
var FloatingTemplateVariable = function FloatingTemplateVariable(_ref20) {
  var _ref20$disableEmpty = _ref20.disableEmpty,
    disableEmpty = _ref20$disableEmpty === void 0 ? false : _ref20$disableEmpty,
    editor = _ref20.editor;
  var _useVisible2 = useVisible(false),
    ref = _useVisible2.ref,
    visible = _useVisible2.visible,
    setVisible = _useVisible2.setVisible;
  var emailVariables = useBaseEmailVariables();
  var emailValues = useBaseEmailVariableValue();
  var isDisableVariable = function isDisableVariable(group, variable) {
    var _emailValues$group2;
    return disableEmpty && !((_emailValues$group2 = emailValues[group]) !== null && _emailValues$group2 !== void 0 && _emailValues$group2.find(function (value) {
      return variable.id === value.id;
    }).value);
  };
  return /*#__PURE__*/jsx(Dropdown, {
    ref: ref,
    visible: visible,
    position: "bottom",
    width: 200,
    anchor: /*#__PURE__*/jsx(IconButton, {
      className: styles$2.floatingTemplateVariable,
      name: "textVariable",
      onClick: function onClick(event) {
        event.preventDefault();
        event.stopPropagation();
        setVisible(!visible);
      }
    }),
    children: /*#__PURE__*/jsx("div", {
      className: styles$2.variableList,
      children: emailVariables && Object.entries(emailVariables).map(function (_ref21) {
        var _ref22 = _slicedToArray$1(_ref21, 2),
          group = _ref22[0],
          variables = _ref22[1];
        return /*#__PURE__*/jsxs(Fragment$1, {
          children: [/*#__PURE__*/jsx(Section, {
            children: toTitleCase(group)
          }), variables.map(function (variable) {
            return /*#__PURE__*/jsx(Item, {
              disabled: isDisableVariable(group, variable),
              onMouseDown: function onMouseDown(event) {
                if (!isDisableVariable(group, variable)) {
                  event.preventDefault();
                  event.stopPropagation();
                  insertTemplateVariable(editor, {
                    id: variable.id,
                    name: variable.name,
                    group: variable.type
                  });
                  setVisible(false);
                }
              },
              children: variable.name
            }, variable.id);
          })]
        }, group);
      })
    })
  });
};
function getDefaultLink(meetingLinks) {
  if (!meetingLinks || (meetingLinks === null || meetingLinks === void 0 ? void 0 : meetingLinks.length) === 0) return 'No meeting links created for this user';
  var defaultLink = meetingLinks === null || meetingLinks === void 0 ? void 0 : meetingLinks.find(function (meetingLink) {
    return meetingLink.defaultLink;
  });
  if ((meetingLinks === null || meetingLinks === void 0 ? void 0 : meetingLinks.length) === 1) {
    return meetingLinks[0];
  } else if (defaultLink) {
    return defaultLink;
  } else {
    return undefined;
  }
}
var EditorToolbarMeetingLink = function EditorToolbarMeetingLink(_ref23) {
  var _Object$keys;
  var _ref23$color = _ref23.color,
    color = _ref23$color === void 0 ? 'white' : _ref23$color;
  var _useForm = useForm(),
    control = _useForm.control,
    handleSubmit = _useForm.handleSubmit,
    reset = _useForm.reset,
    errors = _useForm.errors;
  // @ts-ignore
  var _ref24 = useUserSearch() || [],
    users = _ref24.users;
  var activeUserId = useActiveUserId();
  var activeUsers = users === null || users === void 0 ? void 0 : users.filter(function (_ref25) {
    var active = _ref25.active,
      id = _ref25.id;
    return active && activeUserId !== id;
  });
  var _useState = useState(true),
    _useState2 = _slicedToArray$1(_useState, 2),
    linkOwner = _useState2[0],
    setLinkOwner = _useState2[1];
  var editor = useMyPlateEditorRef(useEventPlateId());
  var type = getPluginType(editor, ELEMENT_MEETING_LINK);
  var _useVisible3 = useVisible(false),
    ref = _useVisible3.ref,
    visible = _useVisible3.visible,
    setVisible = _useVisible3.setVisible;
  var _useState3 = useState(),
    _useState4 = _slicedToArray$1(_useState3, 2),
    selectedUser = _useState4[0],
    setSelectedUser = _useState4[1];
  var _useMeetingLinks = useMeetingLinks(),
    getUserMeetingLinks = _useMeetingLinks.getUserMeetingLinks;
  var meetingLinks = getUserMeetingLinks(selectedUser || activeUserId);
  var defaultLink = getDefaultLink(meetingLinks);
  function resetValues() {
    reset({
      displayText: ''
    });
    setLinkOwner(true);
    setSelectedUser(undefined);
  }
  useEffect(function () {
    if (!visible) resetValues();
  }, [visible]);
  var _useController = useController({
      control: control,
      name: 'displayText',
      rules: {
        required: true
      }
    }),
    textField = _useController.field;
  var _useController2 = useController({
      control: control,
      name: 'meetingLink',
      rules: {
        required: true
      }
    }),
    meetingLinkField = _useController2.field;
  useEffect(function () {
    reset({
      meetingLink: defaultLink === null || defaultLink === void 0 ? void 0 : defaultLink.id
    });
  }, [defaultLink, visible]);
  var handleAddMeetingLink = /*#__PURE__*/function () {
    var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(data, event) {
      var meetingLink;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (editor) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              event.preventDefault();
              meetingLink = {
                type: type,
                userId: selectedUser || '__me__',
                linkId: (data === null || data === void 0 ? void 0 : data.meetingLink) === (defaultLink === null || defaultLink === void 0 ? void 0 : defaultLink.id) && !selectedUser ? '__default__' : data === null || data === void 0 ? void 0 : data.meetingLink,
                children: [{
                  text: data === null || data === void 0 ? void 0 : data.displayText
                }]
              }; //@ts-ignore
              insertNodes(editor, meetingLink);
              setVisible(false);
            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return function handleAddMeetingLink(_x5, _x6) {
      return _ref26.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/jsx("div", {
    className: styles$2.meetingLinkButton,
    children: /*#__PURE__*/jsx(Dropdown, {
      ref: ref,
      visible: visible,
      anchor: /*#__PURE__*/jsx(IconButton, {
        name: "calendar",
        color: color,
        size: 20,
        onClick: function onClick() {
          return setVisible(!visible);
        }
      }),
      children: /*#__PURE__*/jsx("form", {
        children: /*#__PURE__*/jsxs("div", {
          className: styles$2.meetingLinksDropdownWrapper,
          children: [/*#__PURE__*/jsx(Text, {
            size: "m",
            className: styles$2.meetingLinksHeader,
            children: "Meeting Link"
          }), /*#__PURE__*/jsx("div", {
            className: styles$2.meetingLinksTextDisplayInput,
            children: /*#__PURE__*/jsx(Input, _objectSpread$2({
              placeholder: "Text to display *",
              size: "small",
              width: '273px',
              error: (errors === null || errors === void 0 ? void 0 : errors.displayText) && 'This field is required'
            }, textField))
          }), /*#__PURE__*/jsx(Text, {
            size: "m",
            className: styles$2.meetingLinksHeader,
            children: "Link to"
          }), /*#__PURE__*/jsx("div", {
            className: styles$2.radioGroup,
            children: /*#__PURE__*/jsxs(RadioGroup, {
              defaultValue: linkOwner,
              onChange: function onChange(value) {
                setLinkOwner(value);
                if (value) setSelectedUser(activeUserId);
              },
              children: [/*#__PURE__*/jsx(Radio, {
                size: "small",
                value: true,
                expand: true,
                children: /*#__PURE__*/jsx(Text, {
                  size: "s",
                  children: "My meeting links"
                })
              }), /*#__PURE__*/jsx(Radio, {
                size: "small",
                value: false,
                expand: true,
                children: /*#__PURE__*/jsx(Text, {
                  size: "s",
                  children: "Other user\u2018s meeting links"
                })
              })]
            })
          }), /*#__PURE__*/jsxs("div", {
            className: styles$2.dropdownSelects,
            children: [!linkOwner && /*#__PURE__*/jsx(Select, {
              placeholder: "User",
              size: "small",
              borderless: false,
              width: '273px',
              value: selectedUser,
              onChange: setSelectedUser,
              children: activeUsers === null || activeUsers === void 0 ? void 0 : activeUsers.map(function (_ref27) {
                var id = _ref27.id,
                  name = _ref27.name;
                return /*#__PURE__*/jsx(Item, {
                  value: id,
                  children: name
                }, id);
              })
            }), typeof defaultLink === 'string' && selectedUser ? /*#__PURE__*/jsx(Text, {
              size: "s",
              children: defaultLink
            }) : /*#__PURE__*/jsx(Select, _objectSpread$2(_objectSpread$2({
              placeholder: "Meeting Link",
              size: "small",
              borderless: false,
              width: '273px',
              disabled: !selectedUser && !linkOwner,
              error: (errors === null || errors === void 0 ? void 0 : errors.meetingLink) && 'This field is required'
            }, meetingLinkField), {}, {
              children: meetingLinks === null || meetingLinks === void 0 ? void 0 : meetingLinks.map(function (_ref28) {
                var id = _ref28.id,
                  title = _ref28.title;
                return /*#__PURE__*/jsx(Item, {
                  value: id,
                  children: title
                }, id);
              })
            }))]
          }), /*#__PURE__*/jsx("div", {
            className: styles$2.addButton,
            children: /*#__PURE__*/jsx(Button, {
              size: "small",
              disabled: errors && ((_Object$keys = Object.keys(errors)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0 || typeof defaultLink === 'string',
              onClick: handleSubmit(handleAddMeetingLink),
              children: "Add"
            })
          })]
        })
      })
    })
  });
};
var TemplateEditorToolbarMeetingLink = function TemplateEditorToolbarMeetingLink(_ref29) {
  var _Object$keys2;
  var _ref29$color = _ref29.color,
    color = _ref29$color === void 0 ? 'white' : _ref29$color;
  var _useForm2 = useForm(),
    control = _useForm2.control,
    handleSubmit = _useForm2.handleSubmit,
    reset = _useForm2.reset,
    errors = _useForm2.errors;
  // @ts-ignore
  var _ref30 = useUserSearch() || [],
    users = _ref30.users;
  var activeUserId = useActiveUserId();
  var activeUsers = users === null || users === void 0 ? void 0 : users.filter(function (_ref31) {
    var active = _ref31.active;
    return active;
  });
  var _useState5 = useState(true),
    _useState6 = _slicedToArray$1(_useState5, 2),
    linkOwner = _useState6[0],
    setLinkOwner = _useState6[1];
  var editor = useMyPlateEditorRef(useEventPlateId());
  var type = getPluginType(editor, ELEMENT_MEETING_LINK);
  var _useVisible4 = useVisible(false),
    ref = _useVisible4.ref,
    visible = _useVisible4.visible,
    setVisible = _useVisible4.setVisible;
  var _useState7 = useState(),
    _useState8 = _slicedToArray$1(_useState7, 2),
    selectedUser = _useState8[0],
    setSelectedUser = _useState8[1];
  var _useMeetingLinks2 = useMeetingLinks(),
    getUserMeetingLinks = _useMeetingLinks2.getUserMeetingLinks;
  var meetingLinks = getUserMeetingLinks(selectedUser || activeUserId);
  var defaultLink = getDefaultLink(meetingLinks);
  function resetValues() {
    reset({
      displayText: ''
    });
    setLinkOwner(true);
    setSelectedUser(undefined);
  }
  useEffect(function () {
    if (!visible) resetValues();
  }, [visible]);
  var _useController3 = useController({
      control: control,
      name: 'displayText',
      rules: {
        required: true
      }
    }),
    textField = _useController3.field;
  var _useController4 = useController({
      control: control,
      name: 'meetingLink'
    }),
    meetingLinkField = _useController4.field;
  useEffect(function () {
    reset({
      meetingLink: defaultLink === null || defaultLink === void 0 ? void 0 : defaultLink.id
    });
  }, [defaultLink]);
  var handleAddMeetingLink = /*#__PURE__*/function () {
    var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(data, event) {
      var meetingLink;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (editor) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              event.preventDefault();
              meetingLink = {
                type: type,
                userId: selectedUser || '__me__',
                linkId: (data === null || data === void 0 ? void 0 : data.meetingLink) === (defaultLink === null || defaultLink === void 0 ? void 0 : defaultLink.id) && !selectedUser ? '__default__' : data === null || data === void 0 ? void 0 : data.meetingLink,
                children: [{
                  text: data === null || data === void 0 ? void 0 : data.displayText
                }]
              };
              setVisible(false);
              // @ts-ignore
              insertNodes(editor, meetingLink);
            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return function handleAddMeetingLink(_x7, _x8) {
      return _ref32.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/jsx("div", {
    className: styles$2.meetingLinkButton,
    children: /*#__PURE__*/jsx(Dropdown, {
      ref: ref,
      visible: visible,
      width: 321,
      anchor: /*#__PURE__*/jsx(IconButton, {
        name: "calendar",
        color: color,
        size: 20,
        onClick: function onClick() {
          reset();
          setVisible(!visible);
        }
      }),
      children: /*#__PURE__*/jsx("form", {
        children: /*#__PURE__*/jsxs("div", {
          className: styles$2.templateMeetingLinksDropdownWrapper,
          children: [/*#__PURE__*/jsx(Text, {
            size: "m",
            className: styles$2.meetingLinksHeader,
            children: "Meeting Link"
          }), /*#__PURE__*/jsx("div", {
            className: styles$2.meetingLinksTextDisplayInput,
            children: /*#__PURE__*/jsx(Input, _objectSpread$2({
              placeholder: "Text to display *",
              size: "small",
              width: '273px',
              error: (errors === null || errors === void 0 ? void 0 : errors.displayText) && 'This field is required'
            }, textField))
          }), /*#__PURE__*/jsx(Text, {
            size: "m",
            className: styles$2.meetingLinksHeader,
            children: "Link to"
          }), /*#__PURE__*/jsx("div", {
            className: styles$2.radioGroup,
            children: /*#__PURE__*/jsxs(RadioGroup, {
              defaultValue: linkOwner,
              onChange: function onChange(value) {
                setLinkOwner(value);
                if (value) setSelectedUser(activeUserId);
              },
              children: [/*#__PURE__*/jsx(Radio, {
                size: "small",
                value: true,
                expand: true,
                children: /*#__PURE__*/jsx(Text, {
                  size: "s",
                  children: "Sender\u2018s meeting link"
                })
              }), /*#__PURE__*/jsx(Radio, {
                size: "small",
                value: false,
                expand: true,
                children: /*#__PURE__*/jsx(Text, {
                  size: "s",
                  children: "Specific user\u2018s meeting links"
                })
              })]
            })
          }), /*#__PURE__*/jsx("div", {
            className: styles$2.dropdownSelects,
            children: !linkOwner && /*#__PURE__*/jsxs(Fragment, {
              children: [/*#__PURE__*/jsx(Select, {
                placeholder: "User",
                size: "small",
                borderless: false,
                width: '273px',
                value: selectedUser,
                onChange: setSelectedUser,
                children: activeUsers === null || activeUsers === void 0 ? void 0 : activeUsers.map(function (_ref33) {
                  var id = _ref33.id,
                    name = _ref33.name;
                  return /*#__PURE__*/jsx(Item, {
                    value: id,
                    children: id === activeUserId ? "".concat(name, " (You)") : name
                  }, id);
                })
              }), /*#__PURE__*/jsx(Select, _objectSpread$2(_objectSpread$2({
                placeholder: "Meeting Link",
                size: "small",
                borderless: false,
                width: '273px',
                disabled: !selectedUser && !linkOwner,
                error: (errors === null || errors === void 0 ? void 0 : errors.meetingLink) && 'This field is required'
              }, meetingLinkField), {}, {
                children: meetingLinks === null || meetingLinks === void 0 ? void 0 : meetingLinks.map(function (_ref34) {
                  var id = _ref34.id,
                    title = _ref34.title;
                  return /*#__PURE__*/jsx(Item, {
                    value: id,
                    children: title
                  }, id);
                })
              }))]
            })
          }), /*#__PURE__*/jsxs("div", {
            className: styles$2.templateMeetingLinkCallout,
            children: [/*#__PURE__*/jsx(Icon, {
              name: "alertTriangle",
              color: "banana",
              size: 24
            }), /*#__PURE__*/jsx(Text, {
              size: "xs",
              children: "If the sender has not defined or deletes a Meeting Link, the email will not be sent."
            })]
          }), /*#__PURE__*/jsx("div", {
            className: styles$2.addButton,
            children: /*#__PURE__*/jsx(Button, {
              size: "small",
              disabled: errors && ((_Object$keys2 = Object.keys(errors)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.length) > 0 || typeof defaultLink === 'string',
              onClick: handleSubmit(handleAddMeetingLink),
              children: "Add"
            })
          })]
        })
      })
    })
  });
};

var _createPlateUI;
function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var components = createPlateUI((_createPlateUI = {}, _defineProperty$2(_createPlateUI, ELEMENT_TEMPLATE_VARIABLE, TemplateVariable), _defineProperty$2(_createPlateUI, ELEMENT_MISSING_VARIABLE, MissingVariable), _defineProperty$2(_createPlateUI, ELEMENT_MISSING_MEETING_LINK, MissingMeetingLink), _defineProperty$2(_createPlateUI, ELEMENT_MEETING_LINK, MeetingLink), _defineProperty$2(_createPlateUI, ELEMENT_RAW_HTML_BLOCK, RawHTMLBlock), _defineProperty$2(_createPlateUI, ELEMENT_REPLY_HISTORY, ReplyHistory), _defineProperty$2(_createPlateUI, ELEMENT_IMAGE, ImageElement), _defineProperty$2(_createPlateUI, ELEMENT_IMAGE_LINK, ImageLink), _defineProperty$2(_createPlateUI, ELEMENT_H1, withProps(StyledElement, {
  as: 'h1',
  className: styles$4.h1
})), _defineProperty$2(_createPlateUI, ELEMENT_H2, withProps(StyledElement, {
  as: 'h2',
  className: styles$4.h2
})), _defineProperty$2(_createPlateUI, ELEMENT_UL, withProps(StyledElement, {
  as: 'ul',
  className: styles$4.ul
})), _defineProperty$2(_createPlateUI, ELEMENT_OL, withProps(StyledElement, {
  as: 'ol',
  className: styles$4.ol
})), _defineProperty$2(_createPlateUI, ELEMENT_PARAGRAPH$1, withProps(StyledElement, {
  as: 'div',
  className: styles$4.p
})), _createPlateUI));

var css_248z = ".richTextEditor-module_plate_container__c59X1 {\n  width: 100% !important;\n  color: var(--peanut) !important;\n  --artdeco-reset-forms-input-padding: initial;\n  --artdeco-reset-form-position-relative: initial;\n  --artdeco-reset-form-vertical-align-middle: initial;\n  --artdeco-reset-form-display-block: initial;\n  --artdeco-reset-form-black-90: initial;\n  --artdeco-reset-form-label-margin: initial;\n  --artdeco-reset-form-label-opacity: initial;\n  --artdeco-reset-form-webkit-appearance-textfield: initial;\n  --artdeco-reset-form-webkit-appearance-none: initial;\n  --artdeco-reset-form-height-auto: initial;\n  --artdeco-reset-form-padding-top-point-seven-rem: initial;\n  --artdeco-reset-form-rc-pointer-events: initial;\n  --artdeco-reset-form-rc-opacity: initial;\n  --artdeco-reset-form-rc-margin: initial;\n  --artdeco-reset-form-rc-position: initial;\n  --artdeco-reset-form-rc-before-after-content: initial;\n  --artdeco-reset-checkbox-rc-after-content: initial;\n  --artdeco-reset-form-rc-label-display-block: initial;\n  --artdeco-reset-form-rc-label-line-height-2-rem: initial;\n  --artdeco-reset-form-rc-label-margin-bottom-zero: initial;\n  --artdeco-reset-form-rc-label-padding-zero: initial;\n  --artdeco-reset-form-rc-label-position-relative: initial;\n  --artdeco-reset-form-rc-label-padding-left-2point8-rem: initial;\n  --artdeco-reset-forms-input-transition-duration: initial;\n  --artdeco-reset-forms-input-transition-property: initial;\n  --artdeco-reset-forms-input-box-shadow: initial;\n  --artdeco-reset-forms-input-border-radius: 4px;\n  --artdeco-reset-forms-input-border: initial;\n  --artdeco-reset-forms-input-width: initial;\n  --artdeco-reset-forms-input-height: initial;\n  --artdeco-reset-forms-input-box-sizing: border-box;\n  --artdeco-reset-forms-input-background-color: initial;\n  --artdeco-reset-forms-input-color: initial;\n  --artdeco-reset-forms-input-placeholder-color: var(--softPeanut);\n  --artdeco-reset-forms-input-blue: initial;\n  --artdeco-reset-forms-input-focus-box-shadow: initial;\n  --artdeco-reset-forms-input-disabled-hover-border-color: initial;\n  --artdeco-reset-forms-input-disabled-opacity: initial;\n  --artdeco-reset-forms-input-error: initial;\n  --artdeco-reset-forms-font-weight: initial;\n  --artdeco-reset-forms-font-size: initial;\n  --artdeco-reset-forms-line-height: initial;\n  --artdeco-reset-forms-select-appearance-none: initial;\n  --artdeco-reset-forms-select-box-shadow-none: initial;\n  --artdeco-reset-forms-select-outline-zero: initial;\n  --artdeco-reset-forms-select-height-3point2-rem: initial;\n  --artdeco-reset-forms-select-background-transparent: initial;\n  --artdeco-reset-forms-select-position-relative: initial;\n  --artdeco-reset-forms-select-zindex-two: initial;\n  --artdeco-reset-forms-select-background-image: initial;\n  --artdeco-reset-forms-select-border-box: initial;\n  --artdeco-reset-forms-select-border-zero: initial;\n  --artdeco-reset-forms-select-width-100-percent: initial;\n  --artdeco-reset-forms-select-border-radius-point2rem: initial;\n  --artdeco-reset-forms-select-border: initial;\n  --artdeco-reset-forms-select-padding: initial;\n  --artdeco-reset-forms-select-transition: initial;\n  --artdeco-reset-forms-select-disabled-opacity: initial;\n  --artdeco-reset-forms-select-hover-border-color: initial;\n  --artdeco-reset-forms-select-focus-border-color: initial;\n  --artdeco-reset-forms-select-focus-box-shadow: initial;\n  --artdeco-reset-base-margin-zero: initial;\n  --artdeco-reset-base-padding-zero: initial;\n  --artdeco-reset-base-border-zero: initial;\n  --artdeco-reset-base-font-size-hundred-percent: initial;\n  --artdeco-reset-base-font-weight-bold: initial;\n  --artdeco-reset-base-font-style-italic: initial;\n  --artdeco-reset-base-outline-zero: initial;\n  --artdeco-reset-base-outline-none: initial;\n  --artdeco-reset-base-line-height-one: initial;\n  --artdeco-reset-base-display-block: initial;\n  --artdeco-reset-base-list-style-none: initial;\n  --artdeco-reset-base-quotes-none: initial;\n  --artdeco-reset-base-vertical-align-baseline: initial;\n  --artdeco-reset-base-vertical-align-middle: initial;\n  --artdeco-reset-base-background-transparent: initial;\n  --artdeco-reset-base-opacity-zero: initial;\n  --artdeco-reset-base-top-zero: initial;\n  --artdeco-reset-base-position-absolute: initial;\n  --artdeco-reset-base-text-decoration-none: initial;\n  --artdeco-reset-base-text-decoration-line-through: initial;\n  --artdeco-reset-base-border-collapse-collapse: initial;\n  --artdeco-reset-base-get-color-black: initial;\n  --artdeco-reset-base-background-color-ff9: initial;\n  --artdeco-reset-base-border-spacing-zero: initial;\n  --artdeco-reset-base-cursor-help: initial;\n  --artdeco-reset-base-content-none: initial;\n  --artdeco-reset-base-left-minus-hundred-px: initial;\n  --artdeco-reset-base-border-thickness-1-px: initial;\n  --artdeco-reset-base-border-style-dotted: initial;\n}\n\n.richTextEditor-module_plate_container__c59X1 > div > h2 {\n  color: var(--peanut) !important;\n}\n\n.richTextEditor-module_plate_container__c59X1 > div > ul * {\n  list-style: initial;\n}\n\n.richTextEditor-module_plate_container__c59X1 > div > ol * {\n  list-style: auto;\n}\n\n/* Linkedin overrides */\n.richTextEditor-module_plate_container__c59X1 input {\n  margin: 0 !important;\n  box-shadow: none !important;\n  height: 32px;\n  border: none !important;\n  width: 100%;\n}\n\n.richTextEditor-module_plate_container__c59X1 input::-moz-placeholder {\n  color: transparent !important;\n}\n\n.richTextEditor-module_plate_container__c59X1 input::placeholder {\n  color: transparent !important;\n}\n\n.richTextEditor-module_plate_container__c59X1 input:focus {\n  outline: none !important;\n  background-color: transparent;\n}\n\n.richTextEditor-module_plate_container__c59X1 label {\n  margin: 0 !important;\n}\n\n.richTextEditor-module_plate_container__c59X1 button {\n  height: 32px;\n}\n";
var styles = {"plate_container":"richTextEditor-module_plate_container__c59X1"};
styleInject(css_248z);

var MarkBalloonToolbar = function MarkBalloonToolbar(_ref) {
  var id = _ref.id,
    children = _ref.children;
  var editor = useMyPlateEditorRef(id);
  var arrow = false;
  var theme = 'light';
  var buttons = [{
    type: getPluginType(editor, MARK_BOLD),
    icon: /*#__PURE__*/jsx(Icon, {
      name: "textBold"
    }),
    title: 'Bold'
  }, {
    type: getPluginType(editor, MARK_ITALIC),
    icon: /*#__PURE__*/jsx(Icon, {
      name: "textItalic"
    }),
    title: 'Italic'
  }, {
    type: getPluginType(editor, MARK_UNDERLINE),
    icon: /*#__PURE__*/jsx(Icon, {
      name: "textUnderlined"
    }),
    title: 'Underline'
  }];
  var renderMarkButton = function renderMarkButton(index, type, icon, title) {
    return /*#__PURE__*/jsx(Tooltip, {
      title: title,
      position: "top",
      children: /*#__PURE__*/jsx("div", {
        className: styles$4.svgs,
        children: /*#__PURE__*/jsx(MarkToolbarButton$1, {
          type: type,
          icon: icon,
          actionHandler: "onMouseDown"
        })
      })
    }, index);
  };
  var renderButtons = function renderButtons() {
    return buttons.map(function (button, index) {
      return renderMarkButton(index, button.type, button.icon, button.title);
    });
  };
  return /*#__PURE__*/jsx("div", {
    className: styles$4.svgs,
    children: /*#__PURE__*/jsxs(BalloonToolbar, {
      theme: theme,
      arrow: arrow,
      children: [renderButtons(), children]
    })
  });
};

var SaveSnippetButton = function SaveSnippetButton(_ref) {
  var saveSnippetCallback = _ref.saveSnippetCallback;
  var test = useMyPlateEditorRef();
  var selectedNode = usePlateSelection();
  function handleClick() {
    var node = getNodeFragment(test, selectedNode);
    saveSnippetCallback(node);
  }
  return /*#__PURE__*/jsx(Tooltip, {
    title: "Save as snippet",
    position: "top",
    children: /*#__PURE__*/jsx("div", {
      className: styles$4.svgs,
      children: /*#__PURE__*/jsx(ToolbarButton$1, {
        icon: /*#__PURE__*/jsx(Icon, {
          name: "save"
        }),
        onMouseDown: handleClick
      })
    })
  });
};

var getSnippetOnSelectItem = function getSnippetOnSelectItem() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$key = _ref.key,
    key = _ref$key === void 0 ? ELEMENT_MENTION : _ref$key;
  return function (editor, item) {
    var _getBlockAbove;
    var targetRange = comboboxSelectors.targetRange();
    if (!targetRange) return;
    var _getPlugin = getPlugin(editor, key),
      _getPlugin$options = _getPlugin.options,
      insertSpaceAfterMention = _getPlugin$options.insertSpaceAfterMention,
      createMentionNode = _getPlugin$options.createMentionNode;
    var pathAbove = (_getBlockAbove = getBlockAbove(editor)) === null || _getBlockAbove === void 0 ? void 0 : _getBlockAbove[1];
    var isBlockEnd = function isBlockEnd() {
      return editor.selection && pathAbove && isEndPoint(editor, editor.selection.anchor, pathAbove);
    };
    withoutNormalizing(editor, function () {
      var _comboboxSelectors$te;
      // Selectors are sensitive to operations, it's better to create everything
      // before the editor state is changed. For example, asking for text after
      // removeNodes below will return null.
      var _ref2 = createMentionNode(item, {
          search: (_comboboxSelectors$te = comboboxSelectors.text()) !== null && _comboboxSelectors$te !== void 0 ? _comboboxSelectors$te : ''
        }),
        value = _ref2.value;
      select(editor, targetRange);
      withoutMergingHistory(editor, function () {
        return removeNodes(editor, {
          match: function match(node) {
            return node.type === ELEMENT_MENTION_INPUT;
          }
        });
      });
      // @ts-ignore
      insertNodes(editor, value);

      // move the selection after the element
      moveSelection(editor, {
        unit: 'offset'
      });
      if (isBlockEnd() && insertSpaceAfterMention) {
        insertText(editor, ' ');
      }
    });
    return comboboxActions.reset();
  };
};

var _excluded = ["pluginKey", "id"];
function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SnippetCombobox = function SnippetCombobox(_ref) {
  var _ref$pluginKey = _ref.pluginKey,
    pluginKey = _ref$pluginKey === void 0 ? ELEMENT_SNIPPET : _ref$pluginKey,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? pluginKey : _ref$id,
    props = _objectWithoutProperties(_ref, _excluded);
  var editor = usePlateEditorRef$1();
  var _getPluginOptions = getPluginOptions(editor, pluginKey),
    trigger = _getPluginOptions.trigger;
  return /*#__PURE__*/jsx(Combobox, _objectSpread$1({
    id: id,
    trigger: trigger,
    controlled: true,
    onSelectItem: getSnippetOnSelectItem({
      key: pluginKey
    })
  }, props));
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Editor = function Editor(_ref) {
  var setEditor = _ref.setEditor;
  var editor = useMyPlateEditorRef();
  setEditor === null || setEditor === void 0 ? void 0 : setEditor(editor);
  return null;
};
var PlateWrapper = /*#__PURE__*/memo(function (_ref2) {
  var id = _ref2.id,
    placeholder = _ref2.placeholder,
    markBallonEnabled = _ref2.markBallonEnabled,
    saveSnippetCallback = _ref2.saveSnippetCallback,
    setEditor = _ref2.setEditor,
    snippets = _ref2.snippets,
    style = _ref2.style;
  return /*#__PURE__*/jsx("div", {
    className: styles.plate_container,
    onFocus: removeScrollOfBox,
    onBlur: recoverScrollOfBox,
    children: /*#__PURE__*/jsxs(Plate, {
      id: id,
      editableProps: {
        spellCheck: true,
        placeholder: placeholder,
        style: _objectSpread({
          fontSize: '13px',
          fontFamily: 'Arial, Helvetica, sans-serif',
          padding: 12
        }, style)
      },
      children: [markBallonEnabled && /*#__PURE__*/jsx(MarkBalloonToolbar, {
        id: id,
        children: snippets && /*#__PURE__*/jsx(SaveSnippetButton, {
          saveSnippetCallback: saveSnippetCallback
        })
      }), /*#__PURE__*/jsx(Editor, {
        setEditor: setEditor
      }), /*#__PURE__*/jsx(SnippetCombobox, {
        items: snippets
      })]
    })
  });
});

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var initialValue = [{
  type: ELEMENT_PARAGRAPH$1,
  children: [{
    text: ''
  }]
}];
var RichTextEditor = function RichTextEditor(_ref) {
  var _children;
  var id = _ref.id,
    value = _ref.value,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? initialValue : _ref$defaultValue,
    style = _ref.style,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    plugins = _ref.plugins,
    children = _ref.children,
    setEditor = _ref.setEditor,
    snippets = _ref.snippets,
    saveSnippetCallback = _ref.saveSnippetCallback;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    plateId = _useState2[0],
    setPlateId = _useState2[1];
  var oldPlateId = useRef(null);
  var emailVariablesValues = useBaseEmailVariableValue();
  var pluginsToUse = useMemo(function () {
    var myPlugins = createMyPlugins(plugins, {
      components: components
    });
    return myPlugins;
  }, [hash(plugins)]);
  var templateVariableEnabled = pluginsToUse.some(function (plugin) {
    return plugin.key === 'variable';
  });
  var markBallonEnabled = pluginsToUse.some(function (plugin) {
    return plugin.key === 'basicMarks';
  });
  useEffect(function () {
    if (templateVariableEnabled && emailVariablesValues && Object.keys(emailVariablesValues).length > 0) {
      if (id) {
        id = "".concat(id, "_").concat(hash(emailVariablesValues));
      } else {
        id = hash(emailVariablesValues);
      }
    } else {
      id = id || 'plateEditor';
    }
    setPlateId(id);
  }, [id, templateVariableEnabled, emailVariablesValues]);
  useEffect(function () {
    if (oldPlateId.current !== plateId) {
      oldPlateId.current = plateId;
    }
  }, [plateId]);
  if (!plateId) {
    return null;
  }
  if (plateId !== id && oldPlateId.current && oldPlateId.current !== plateId) {
    return null;
  }
  var PlateEditor = /*#__PURE__*/jsx(PlateWrapper, {
    id: plateId,
    placeholder: placeholder,
    markBallonEnabled: markBallonEnabled,
    setEditor: setEditor,
    snippets: snippets,
    style: style,
    saveSnippetCallback: saveSnippetCallback
  });
  return /*#__PURE__*/jsx(PlateProvider, {
    id: plateId,
    value: value,
    initialValue: defaultValue,
    onChange: onChange,
    plugins: pluginsToUse,
    children: (_children = children === null || children === void 0 ? void 0 : children(PlateEditor)) !== null && _children !== void 0 ? _children : PlateEditor
  });
};

var ELEMENT_PARAGRAPH = 'p';

/**
 * Enables support for paragraphs.
 */
var createCustomParagraphPlugin = createPluginFactory$1({
  key: ELEMENT_PARAGRAPH,
  isElement: true,
  handlers: {
    onKeyDown: onKeyDownToggleElement
  },
  options: {
    hotkey: ['mod+opt+0', 'mod+shift+0']
  },
  deserializeHtml: {
    rules: [{
      validNodeName: 'DIV'
    }, {
      validNodeName: 'P'
    }],
    query: function query(el) {
      return el.style.fontFamily !== 'Consolas';
    }
  }
});

var createSnippetPlugins = function createSnippetPlugins() {
  return [createComboboxPlugin(), createMentionPlugin({
    key: ELEMENT_SNIPPET,
    options: {
      // @ts-ignore
      createMentionNode: function createMentionNode(mention) {
        return {
          value: mention.data
        };
      },
      trigger: '/',
      insertSpaceAfterMention: true
    }
  })];
};

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var useRichTextEditorPlugins = function useRichTextEditorPlugins() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$templateVariable = _ref.templateVariables,
    templateVariables = _ref$templateVariable === void 0 ? true : _ref$templateVariable,
    _ref$replaceTemplateV = _ref.replaceTemplateVariables,
    replaceTemplateVariables = _ref$replaceTemplateV === void 0 ? false : _ref$replaceTemplateV,
    _ref$marks = _ref.marks,
    marks = _ref$marks === void 0 ? true : _ref$marks,
    _ref$elements = _ref.elements,
    elements = _ref$elements === void 0 ? true : _ref$elements,
    _ref$images = _ref.images,
    images = _ref$images === void 0 ? true : _ref$images,
    _ref$snippets = _ref.snippets,
    snippets = _ref$snippets === void 0 ? false : _ref$snippets,
    _ref$singleLine = _ref.singleLine,
    singleLine = _ref$singleLine === void 0 ? false : _ref$singleLine,
    _ref$autoReplace = _ref.autoReplace,
    autoReplace = _ref$autoReplace === void 0 ? true : _ref$autoReplace,
    _ref$rawHTMLBlock = _ref.rawHTMLBlock,
    rawHTMLBlock = _ref$rawHTMLBlock === void 0 ? false : _ref$rawHTMLBlock,
    _ref$replyHistory = _ref.replyHistory,
    replyHistory = _ref$replyHistory === void 0 ? false : _ref$replyHistory,
    _ref$replaceMeetingLi = _ref.replaceMeetingLinks,
    replaceMeetingLinks = _ref$replaceMeetingLi === void 0 ? false : _ref$replaceMeetingLi,
    _ref$stopPropagationP = _ref.stopPropagationPlugin,
    stopPropagationPlugin = _ref$stopPropagationP === void 0 ? true : _ref$stopPropagationP,
    _ref$replaceParagraph = _ref.replaceParagraphs,
    replaceParagraphs = _ref$replaceParagraph === void 0 ? false : _ref$replaceParagraph;
  var createTemplateVariablesPlugin = useTemplateVariablesPlugin({
    replace: replaceTemplateVariables
  });
  var createMeetingLinksPlugin = useTemplateMeetingLinksPlugin(replaceMeetingLinks);
  return useMemo(function () {
    var basePlugins = [];
    if (replaceParagraphs) {
      basePlugins = [].concat(_toConsumableArray(basePlugins), [createCustomParagraphPlugin()]);
    }
    if (elements) {
      basePlugins = [].concat(_toConsumableArray(basePlugins), _toConsumableArray(createElementsPlugins()));
    }
    if (elements || templateVariables) {
      basePlugins = [].concat(_toConsumableArray(basePlugins), _toConsumableArray(createControlPlugins()));
    }
    if (autoReplace) {
      basePlugins = [].concat(_toConsumableArray(basePlugins), _toConsumableArray(createReplacePlugins()));
    }
    if (marks) {
      basePlugins = [].concat(_toConsumableArray(basePlugins), [createBasicMarksPlugin()]);
    }
    if (singleLine) {
      basePlugins = [].concat(_toConsumableArray(basePlugins), [createSingleLinePlugin()]);
    }
    if (images) {
      basePlugins = [].concat(_toConsumableArray(basePlugins), [createImagePlugin()]);
    }
    if (rawHTMLBlock) {
      basePlugins = [].concat(_toConsumableArray(basePlugins), [createRawHTMLBlockPlugin()]);
    }
    if (replyHistory) {
      basePlugins = [].concat(_toConsumableArray(basePlugins), [createReplyHistoryPlugin()]);
    }
    if (snippets) {
      basePlugins = [].concat(_toConsumableArray(basePlugins), _toConsumableArray(createSnippetPlugins()));
    }
    if (templateVariables) {
      basePlugins = [].concat(_toConsumableArray(basePlugins), [createTemplateVariablesPlugin]);
    }
    basePlugins = [].concat(_toConsumableArray(basePlugins), [createMeetingLinksPlugin]);
    return basePlugins;
  }, [createTemplateVariablesPlugin, createMeetingLinksPlugin, templateVariables, replaceTemplateVariables, stopPropagationPlugin, marks, rawHTMLBlock, elements, images, singleLine, replyHistory, snippets]);
};

var deserialize = function deserialize(content) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? 'AST' : _ref$format,
    _ref$plugins = _ref.plugins,
    plugins = _ref$plugins === void 0 ? [] : _ref$plugins;
  if (!content) {
    return undefined;
  }
  if (format === 'HTML') {
    var editor = createPlateUIEditor({
      plugins: plugins
    });
    return deserializeHtml(editor, {
      element: content
    });
  } else {
    return JSON.parse(content);
  }
};

// This function is only meant for serializing context-free template like when they appear in the card list
var serialize = function serialize(content) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$format = _ref2.format,
    format = _ref2$format === void 0 ? 'AST' : _ref2$format,
    _ref2$plugins = _ref2.plugins,
    plugins = _ref2$plugins === void 0 ? [] : _ref2$plugins;
  var editor = createPlateUIEditor({
    plugins: plugins
  });
  if (!content) {
    return '';
  }
  var nodes;
  // For backwards compatibility
  if (format === 'HTML') {
    nodes = deserialize(content, {
      format: format,
      plugins: plugins
    });
  } else {
    nodes = typeof content === 'string' ? JSON.parse(content) : content;
  }
  var html = serializeHtml(editor, {
    nodes: nodes,
    stripWhitespace: false
  });
  var raw = html.replaceAll(/<div(\s*)?>\s*<\/div>/g, '<br>').replaceAll('&#x27;', "'").replaceAll('&lt;', '<').replaceAll('&gt;', '>').replaceAll('&amp;', '&').replaceAll('&quot;', '"').replaceAll('&apos;', "'");
  return raw;
};

export { ELEMENT_MEETING_LINK, ELEMENT_MISSING_MEETING_LINK, ELEMENT_MISSING_VARIABLE, ELEMENT_RAW_HTML_BLOCK, ELEMENT_REPLY_HISTORY, ELEMENT_SNIPPET, ELEMENT_TEMPLATE_VARIABLE, EditorToolbar, EditorToolbarControlsSection, EditorToolbarFileAttachment, EditorToolbarFontStylesSection, EditorToolbarImage, EditorToolbarLink, EditorToolbarListsSection, EditorToolbarMeetingLink, EditorToolbarSection, EditorToolbarSnippet, EditorToolbarTemplateVariable, EditorToolbarTextMarksSection, FloatingTemplateVariable, RichTextEditor, TemplateEditorToolbarFileAttachment, TemplateEditorToolbarImage, TemplateEditorToolbarMeetingLink, createImagePlugin, createRawHTMLBlock, createRawHTMLBlockPlugin, createReplyHistory, createReplyHistoryPlugin, deserialize, exitBreakPlugin, format, formatList, hasMissingVariables, initialValue, insertImage, insertImageLink, insertMeetingLink, insertRawHTMLBlock, insertTemplateVariable, linkPlugin, preFormat, resetBlockTypePlugin, selectOnBackspacePlugin, serialize, useRichTextEditorPlugins, useTemplateMeetingLinksPlugin, useTemplateVariablesPlugin };
